// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Fonts/e9167238-3b3f-4813-a04a-a384394eed42.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("Fonts/2cd55546-ec00-4af9-aeca-4a3cd186da53.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Fonts/1e9892c0-6927-4412-9874-1b82801ba47a.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("Fonts/46cf1067-688d-4aab-b0f7-bd942af6efd8.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Fonts/52a192b1-bea5-4b48-879f-107f009b666f.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("Fonts/dccb10af-07a2-404c-bfc7-7750e2716bc1.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Fonts/14c73713-e4df-4dba-933b-057feeac8dd1.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("Fonts/b8e906a1-f5e8-4bf1-8e80-82c646ca4d5f.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("Fonts/890bd988-5306-43ff-bd4b-922bc5ebdeb4.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("Fonts/ed104d8c-7f39-4e8b-90a9-4076be06b857.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/data-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/circle1-patient.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/circle2-patient.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/box1-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/box1-yellow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/change-link.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/2_circle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/3_circle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/4_circle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/isi-gr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/using1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/using2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/using3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/using4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/using5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/using-hcp1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../images/using-hcp2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../images/using3-hcp.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/using-hcp4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../images/circle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../images/circle1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../images/circle2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../images/check.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../images/pencil.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../images/using1-m.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../images/using3-m.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../images/using2-m.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../images/using4-m.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../images/using5-m.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../images/icon-gear.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../images/key-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../images/logout-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../images/user-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../images/check-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../images/sag-left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../images/sag-right.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#52a192b1-bea5-4b48-879f-107f009b666f" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#ed104d8c-7f39-4e8b-90a9-4076be06b857" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * HTML5 Boilerplate
 *
 * What follows is the result of much research on cross-browser styling.
 * Credit left inline and big thanks to Nicolas Gallagher, Jonathan Neal,
 * Kroc Camen, and the H5BP dev community and team.
 */

/* ==========================================================================
   Base styles: opinionated defaults
   ========================================================================== */

@font-face {
    font-family: "AvenirNextLTW01-Regular";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("eot"),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"),
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
}
@font-face {
    font-family: "Avenir Next LT W01 Bold";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("eot"),
        url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"),
        url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"),
        url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg");
}
strong {
    font-family: "Avenir Next LT W01 Bold";
}
a strong {
    color: #83156f;
}
b {
    font-family: "Avenir Next LT W01 Bold";
}

@media only screen and (max-width: 767px) {
    .small-login {
        width: 100%;
    }
    .home-page-announcement .popup-box .close-button {
        float: none;
    }
    .footer .float-right {
        padding-left: 0;
    }
    .home-page-announcement .popup-box {
        width: 90%;
        height: 90%;
    }
}
@media only screen and (max-width: 1024px) {
    .home-page-announcement {
        padding: 0;
    }
}

html,
button,
input,
select,
textarea {
    color: #222;
}
html {
    width: 100%;
}
body {
    font-size: 16px;
    color: #4d4d4f;
    font-family: "AvenirNextLTW01-Regular";
    line-height: 23px;
}
header {
    padding-top: 15px;
    padding-bottom: 15px;
}
a.logo {
    float: left;
}
.noWrap,
.nowrapTxt {
    white-space: nowrap;
}
#submit-skip {
    float: right;
    margin-top: -20px;
}
.leftSpace {
    border-right: 1px solid #000;
    float: left;
    width: 35%;
    padding-right: 30px;
    margin-bottom: 40px;
}
p.dob label {
    padding-bottom: 5px;
    width: 100%;
    text-align: left;
}
p.dob input.datepicker {
    width: 220px;
}
.rightSpace {
    float: left;
    padding-left: 40px;
    /* padding-top: 20px; */
    width: 40%;
}
.find_pass form {
    width: 350px;
    margin: 0 auto;
    margin-bottom: 20px;
}
.find_pass label {
    display: none;
}

.refnum {
    width: 300px;
}
.refnum label {
    display: none;
}
input.datepicker {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    background-repeat: no-repeat;
    background-position: right;
    background-size: 27px;
}
#fancybox-close {
    background: none;
    color: #83156f !important;
    background-color: #fff !important;
    border: 2px solid #83156f !important;
    border-radius: 7px !important;
    padding: 7px;
    display: block;
    left: 0;
    top: 0px;
    margin-bottom: 20px;
    width: auto;
    float: left;
    height: auto;
    margin-top: 10px;
    padding-left: 15px;
    padding-right: 15px;
    position: relative;
    font-size: 16px;
}
#tabs-2 .border-color {
    border: 0;
    padding: 0;
    margin-bottom: 20px;
    margin-top: 20px;
}
.content-holder p {
    width: 100%;
    float: left;
    font-size: 16px;
}
table.eligibility select {
    padding: 12px;
    margin-top: 5px;
    border-radius: 5px;
    border: 1px solid #ddd;
}
.dob .error {
    width: 100%;
    font-size: 13px;
}
.apply-step-one-form p {
    margin-bottom: 10px;
}
.underline {
    text-decoration: underline;
    display: block;
    margin-bottom: 5px;
}
.search-div {
    width: 100%;
    float: left;
    margin-bottom: 20px;
}
.user-box {
    background-color: #f2f2f2;
    padding: 10px;
    width: 200px;
}
.links {
    width: 100%;
    display: block;
    float: left;
    margin-top: 10px;
    margin-bottom: 7px;
}
ul.user-area {
    float: right;
    width: auto;
    padding-left: 20px;
}
.nav.user-area .icon-mm a {
    margin-bottom: 0;
    margin-top: 0;
    font-family: "AvenirNextLTW01-Regular";
}
.nav.user-area .icon-mm {
    margin-right: 0;
    margin-left: 0;
}
.nav.user-area .icon-mm a {
    padding: 0px !important;
    margin-bottom: 8px;
}
.nav.user-area .icon-mm a.round-mm {
    padding: 5px !important;
    color: #83156f;
}
.grey {
    background-color: #f2f2f2;
    padding: 20px;
    margin-bottom: 20px;
    padding-top: 0;
}
.site-text-size {
    margin-top: 5px;
    float: right;
    clear: both;
}
.site-text-size span {
    display: block;
    padding-top: 7px;
    float: left;
    padding-right: 5px;
    color: #83156f;
    font-size: 15px;
    padding-top: 0;
    line-height: 25px;
}
.site-text-sm {
    font-size: 14px;
    padding-top: 5px;
}
.site-text-md {
    font-size: 18px;
    padding-top: 3px;
}
.site-text-toggle.active {
    color: #83156f;
    border: 1px solid #83156f;
}
.site-text-lg {
    font-size: 22px;
    display: inline-block;
    line-height: 22px;
}
.content-buttons p {
    float: left;
    width: 100%;
}
.five-cost li {
    margin-left: 17px !important;
    margin-bottom: 0 !important;
}
.call {
    float: left;
    width: 70%;
}
.fax {
    float: left;
    width: 100%;
    margin-bottom: 5px;
}
.shadow-box {
    width: 100%;
    display: block;
    float: left;
    margin-bottom: 30px;
    padding: 20px;
    box-shadow: 0px 3px 8px 2px #b5b5b5;
}
.section {
    width: 100%;
    display: block;
    float: left;
}
.section h2 {
    margin-top: 0;
}
.section label {
    width: 95%;
    text-align: left;
    line-height: 20px !important;
}
.section input[type="text"] {
    width: 95%;
    border: 1px solid #d8d8d8;
    padding: 10px;
    border-radius: 4px 4px 4px 4px;
    padding-top: 15px;
}
.section button[type="reset"] {
    background-color: #fff;
    border: 1px solid #d8d8d8 !important;
    color: #4d4d4f;
}
.small-login {
    width: 400px;
    margin: 0 auto;
    min-height: 200px;
}
.small-login label {
    width: 100%;
    text-align: left;
    padding-bottom: 5px;
}
.small-login input[type="text"],
.small-login input[type="password"] {
    width: 100%;
    max-width: 100%;
}
.clear {
    width: 100%;
    display: block;
    height: 20px;
    clear: both;
}

.section .select_container {
    width: 95%;
    border: 1px solid #d8d8d8;
    padding: 10px;
    border-radius: 4px 4px 4px 4px;
    padding-top: 15px;
}
.section .select_container select {
    max-width: 100%;
    width: 100%;
}
.section p.date img {
    display: none;
}
.section p {
    min-height: 70px;
}
.enroll-form .section p {
    min-height: inherit;
}
.section p.blue {
    min-height: inherit;
    color: #83156f;
    padding-bottom: 15px;
}
.inner-label {
    background: #fff;
    display: block;
    float: left;
    margin-bottom: -14px;
    padding: 7px;
    margin-left: 5px;
    padding-left: 5px;
    position: relative;
}
#home-container p input {
    max-width: 270px;
    width: 270px;
    padding: 10px;
    padding-top: 15px;
    padding-bottom: 15px;
    border: 1px solid #ddd;
    font-size: 13px;
}
#home-container form p {
    clear: both;
    float: left;
    width: 270px;
    clear: none;
    margin-right: 10px;
}
#patient-eligibility h3 {
    font-weight: normal;
    color: #83156f;
    margin-top: 10px;
}
#patient-eligibility p {
    margin-bottom: 20px;
}
#patient-eligibility .circle1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
#patient-eligibility .circle2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
#patient-eligibility .circle1,
#patient-eligibility .circle2 {
    background-repeat: no-repeat;
    background-size: 105px 105px;
    background-position: center left;
    padding-left: 125px;
    min-height: 105px;
    background-repeat: no-repeat;
}
#patient-eligibility .help {
    color: #83156f;
}
#patient-eligibility .circle p {
    font-size: 1.25em;
    padding-bottom: 50px;
    padding-left: 0;
    padding-top: 5px;
    line-height: 30px;
}
#patient-eligibility .circle-div p {
    line-height: 25px;
    padding-top: 5px;
}
#patient-eligibility .title-box2-drug {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
#patient-eligibility .title-box2-inf {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
#patient-eligibility .help p {
    display: block;
    margin-bottom: 0;
}
#patient-eligibility .circle {
    padding-left: 50px;
}
#patient-eligibility .circle-div {
    padding-bottom: 63px;
}

.content-buttons .col-lg-4 {
    padding-left: 20px;
    padding-right: 20px;
}
.mobile {
    display: none;
}
#home-container button {
    padding: 10px;
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 3px;
}
.title-home {
    width: 100%;
    float: left;
    color: #fff;
    text-align: center;
    font-size: 27px;
    line-height: 35px;
    height: 82px;
    background-color: #83156f;
    padding-bottom: 0;
    padding-top: 25px;
    border-radius: 30px 30px 0 0;
    text-align: center;
}
.vabysmo-img {
}
.ui-tabs .ui-tabs-nav li {
    margin: 0 !important;
}
.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited {
}
#home-container-patients img {
    max-width: 100%;
}
.hcp #home-container-patients a {
    text-decoration: underline;
    color: #00f;
}

.after-title {
    width: 100%;
    float: left;
    background-color: #f2f2f2;
    padding: 30px;
    color: #83156f;
    padding-left: 50px;
    padding-right: 50px;
}
.cost1 {
    padding-left: 40px;
}
.after-title p {
    font-size: 22px;
    text-align: center;
    font-weight: bold;
    padding-bottom: 20px;
}
.center-cols {
    width: 100%;
    float: left;
    background-color: #f2f2f2;
}
.center-col_1 {
    width: 33.3%;
    float: left;
    text-align: center;
    padding: 30px;
    border-right: 1px solid #83156f;
}
.center-col_2 {
    width: 33.3%;
    float: left;
    text-align: center;
    padding: 30px;
    border-right: 1px solid #83156f;
}
.center-col_3 {
    width: 33.3%;
    float: left;
    text-align: center;
    padding: 30px;
}
.center-cols img {
    margin-bottom: 20px;
}
.five-cost {
    width: 50%;
    float: left;
    color: #83156f;
    font-size: 15px;
}
.five-cost strong {
    font-size: 15px;
}
.five-cost span {
    padding-right: 40px;
    display: block;
}
.five-cost img {
    float: left;
    margin-right: 15px;
    margin-bottom: 30px;
}
.patients .ui-datepicker table {
    overflow-x: auto !important;
    font-size: 13px !important;
    display: table;
}
.site-text-toggle {
    display: inline-block;
    border: 1px solid #83156f;
    height: 25px;
    width: 25px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    padding-top: 0;
}
a.size {
    color: #83156f !important;
    font-weight: bold;
}
#enlarger-size-small,
#enlarger-size-medium,
#enlarger-size-large {
    text-decoration: none;
}
.left_text {
    width: 40%;
    float: left;
}
.right_text {
    width: 50%;
    float: left;
    padding: 20px;
    box-shadow: 0 0 7px;
    margin-bottom: 40px;
}
ul.submenuitems {
    display: none;
    position: absolute;
    left: 0;
    z-index: 2;
    border-top: 0;
    min-width: 99%;
}
ul.submenuitems li {
    width: 100% !important;
    text-align: left;
    border-radius: 0px;
    border-top: 1px solid #fff;
}
ul.submenuitems li a {
    width: 100%;
    padding: 7px 15px;
    text-align: center;
}
#header-patients li {
}
.arrow {
    border: solid #4d4d4f;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 3px;
    margin-left: 5px;
    margin-bottom: 3px;
}
.down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}
.nav .icon-mm {
    float: right;
    margin-right: 140px;
    width: 55px;
}
.line-user {
    width: 100%;
}
.mm {
    padding-top: 10px;
    padding-bottom: 20px;
}
.round-mm {
    width: 40px;
    height: 35px;
    border-radius: 50px;
    text-align: center;
    padding: 5px;
    border: 1px solid #4d4d4f;
    margin: 10px;
    margin-bottom: 20px;
    margin-top: 0;
    float: left;
    font-weight: bold;
}
#header-patients li ul li {
    width: 100%;
}
#header-patients li.has-child {
}
.submenuitems li a {
    border: 0 !important;
    margin: 0;
}
li.has-child a:hover .arrow {
    border: solid #fff;
    border-width: 0 1px 1px 0;
}
li.has-child:hover ul.submenuitems {
    display: block;
}
.clear {
    width: 100%;
    display: block;
}
.right_text .underline {
    display: block;
    margin-bottom: 7px;
    text-decoration: underline;
}
.tooltip {
    position: relative;
    display: inline-block;
}
a.ot-sdk-show-settings {
    color: #fff !important;
    cursor: pointer;
}
/* Tooltip text */
.tooltip .tooltiptext {
    visibility: hidden;
    width: 230px;
    background-color: #83156f;
    color: #fff;
    text-align: center;
    padding: 15px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    font-size: 12px;
    left: -240px;
    top: -50px;
}
img.excel {
    margin-bottom: 10px;
    width: 30px;
}
.hp-footer-bar {
    background-color: #83156f;
    height: 15px;
    border-radius: 0 0 30px 30px;
    margin-bottom: 30px;
    width: 100%;
    float: left;
}
.tooltip a {
    text-decoration: none !important;
}
/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
    visibility: visible;
}
.mat-card {
    transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
    display: block;
    position: relative;
    padding: 16px;
    border-radius: 4px;
    background: #eee;
}
.small-login p {
    margin-bottom: 20px;
}
.find_patient p {
    margin-bottom: 20px;
}
#hcp_post_content {
    width: 100%;
    display: block;
    float: left;
}
.leftSpace input[type="text"] {
    width: 100%;
    max-width: 150px;
}
#hcp_post_content .find_patient p {
    width: 100% !important;
    float: left !important;
}
.status-icon.active {
    border-radius: 20px;
    padding-left: 5px;
    padding-right: 5px;
    background-color: #24ae3d;
    color: #fff;
    display: inline-block;
    margin-top: 2px;
    min-width: 30px;
    text-align: center;
    font-size: 13px;
    margin-left: 7px;
    line-height: 15px;
    padding: 5px;
}
.status-icon.inactive {
    border-radius: 20px;
    padding-left: 5px;
    padding-right: 5px;
    background-color: #ffcc33;
    color: #000;
    display: inline-block;
    min-width: 30px;
    text-align: center;
    font-size: 13px;
    margin-left: 7px;
    line-height: 15px;
    padding: 5px;
}
.status-icon.rejected {
    border-radius: 20px;
    padding-left: 5px;
    padding-right: 5px;
    background-color: #e1304c;
    color: #fff;
    display: inline-block;
    margin-top: 2px;
    min-width: 30px;
    text-align: center;
    font-size: 13px;
    cursor: pointer;
    margin-left: 7px;
    line-height: 15px;
    padding: 5px;
}
button[type="reset"] {
    background-color: #fff;
    border: 2px solid #d8d8d8 !important;
    color: #4d4d4f !important;
}
.patientProfile table {
    margin-top: 0px;
}
.color {
    color: #83156f;
    font-weight: normal;
    margin-top: 0;
}
.profile-box label {
    width: 100%;
    text-align: left;
    margin-bottom: 4px;
}
.profile-box input[type="text"] {
    width: 95%;
    margin: 0;
    padding: 7px;
    border-radius: 4px;
}
.profile-box .select_container {
    width: 95%;
    margin: 0;
    padding: 7px;
    border-radius: 4px;
}
.profile-box select {
    border: 0;
    max-width: 100%;
    width: 100%;
}
.find_patient input[type="text"] {
    max-width: 100%;
    width: 22%;
    padding: 7px;
    float: left;
    margin-right: 20px;
}
.find_patient input[type="password"] {
    max-width: 100%;
    width: 95%;
    padding: 7px;
    float: left;
    margin-right: 20px;
}
.form-validate-create-password input[type="text"] {
    max-width: 100%;
    width: 95%;
    padding: 12px;
    float: left;
    margin-right: 20px;
}
.form-validate-password label {
    text-align: left;
    width: 100%;
    padding-bottom: 7px;
}
.form-validate-password .prompt-error {
    font-size: 12px;
}

.form-validate-create-password label {
    text-align: left;
    width: 100%;
    padding-bottom: 7px;
}
.form-validate-create-password .prompt-error {
    font-size: 12px;
    width: 100%;
}
.thank-you h3 {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    margin-bottom: 20px;
    color: #83156f;
}
.thank-you span {
    color: #83156f;
}
.thank-you .col-sm-12 {
    margin-bottom: 15px;
}
.patients .thank-you table {
    width: 50%;
    border-spacing: 0px;
}
.patients .thank-you th {
    background: none;
    color: #83156f;
    border-bottom: 1px solid #83156f;
}
.patients .thank-you td {
    background: none;
    border-bottom: 1px solid #4d4d4f;
}
.find_patient .select_container {
    max-width: 100%;
    width: 22%;
    padding: 7px;
    float: left;
    margin-right: 20px;
}
label.ssn {
    margin-bottom: 20px !important;
}
b {
    font-weight: 900;
}
.pi_tab1 {
    width: 60% !important;
}
.pi_tab1.second_row {
    width: 40% !important;
}
.user-area {
    padding: 0 0 8px;
    margin: 0;
    list-style: none;
    line-height: 1.44em;
    float: right;
    margin-top: 20px;
}
.user-area li {
    float: left;
    list-style: none;
}
.user-area .size {
    padding: 0 40px 0 0;
    /*background: url(../images/sprite-1.png) no-repeat 100% 0;*/
}
.user-area a {
    float: left;
    text-decoration: none;
    color: #83156f !important;
}
/*
  * Remove text-shadow in selection highlight: h5bp.com/i
  * These selection declarations have to be separate.
  * Customize the background color to match your design.
  */
input#fileupload,
input#fileupload2 {
    height: 60px;
    width: 250px;
}
.isi strong {
    color: #83156f;
}

.isi h2 {
    font-size: 16px !important;
}
#progress {
    float: left;
}
#progress2 {
    float: left;
}
.top {
    width: 100%;
    background-color: #f5f5f5;
}
.top-header {
    width: 40%;
    float: right;
}
.top a {
    color: #fff !important;
    background-color: #83156f;
    background-image: none;
    padding: 10px;
    display: block;
    float: left;
    text-decoration: none;
    font-size: 15px;
}
.top-header nav a {
    color: #83156f;
    background-image: none;
    display: block;
    float: right;
    text-decoration: none;
    margin-top: 5px;
    margin-right: 0px;
    font-weight: bold;
    margin-bottom: 5px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    background-repeat: no-repeat;
    background-position: right;
    padding-right: 30px;
}
.hcp .top-header nav a.active {
    color: #4d4d4f !important;
    background-color: #fff;
    padding: 10px;
    display: block;
    float: left;
    text-decoration: none;
    font-size: 15px;
    background-image: none;
    font-weight: bold;
    text-decoration: underline;
}
.patients .top a.active {
    color: #4d4d4f !important;
    padding: 10px;
    display: block;
    float: left;
    text-decoration: none;
    font-size: 15px;
    background-image: none;
    background-color: #fff;
    font-weight: bold;
    text-decoration: underline;
}
h2 a {
    color: #83156f;
}
.hcp-solutions {
    float: right !important;
    background-color: #83156f !important;
    color: #fff;
    background-image: none !important;
    padding-left: 40px !important;
    padding-right: 40px !important;
    border-radius: 3px;
}
nav.hcp {
    width: 100%;
}
.hcp button {
    background-color: #fff;
    color: #83156f !important;
    border: 2px solid #83156f;
    border-radius: 7px;
    color: #fff;
    padding: 7px;
    padding-left: 15px;
    padding-right: 15px;
    text-decoration: none;
    margin-right: 20px;
}
.patients button {
    background-color: #fff;
    color: #83156f !important;
    border: 2px solid #83156f;
    border-radius: 7px;
    color: #fff;
    padding: 8px;
    padding-left: 15px;
    padding-right: 15px;
    text-decoration: none;
    margin-right: 20px;
}
.loading {
    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);
    bottom: 0;
    display: none;
    left: 0;
    padding: 5%;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9999;
}
.loading .popup-box {
    margin: 0 auto;
    width: 300px;
    overflow: auto;
    padding-bottom: 20px;
    text-align: center;
}
button:disabled {
    background-image: none;
}
.hcp button.submit-hcp {
    background-color: #83156f;
}
.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
    border: 1px solid #83156f !important;
}
.patients button.submit-patients {
    background-color: #83156f;
    color: #fff !important;
}
.eligibility .box-drug ul {
}
.title-box2-drug {
}
.radio {
    display: block;
    position: relative;
    padding-left: 25px;
    margin-bottom: 5px;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
}
.radios .radio {
    padding-top: 0;
}
.radio input {
    position: absolute;
    opacity: 0;
}
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border: 1px solid #4d4d4f;
    border-radius: 50%;
}
label.radio {
    text-align: left;
    width: auto;
}
/* On mouse-over, add a grey background color */
.radio:hover input ~ .checkmark {
    background-color: #fff;
}

/* When the radio button is checked, add a blue background */
.radio input:checked ~ .checkmark {
    background-color: #fff;
    border: 1px solid #83156f;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio input:checked ~ .checkmark:after {
    display: block;
}
.using-the-program {
}
.using-the-program table {
    border-collapse: separate;
    border-spacing: 0px;
    width: 100%;
    font-size: inherit;
    margin-bottom: 20px;
}
.using-the-program h1 {
    font-size: 1.5em;
}
.using-the-program table td.first {
    width: 10px;
}
.using-the-program ul {
    color: #83156f;
    font-size: inherit;
    margin-top: 10px;
    margin-left: 20px;
}
.using-the-program table td {
    background-color: transparent;
    border: 0;
    vertical-align: top;
    padding: 2px !important;
    color: #83156f;
    line-height: 20px;
    font-weight: 600;
}
.using-the-program img {
    margin-left: -30px;
    margin-top: -28px;
    margin-bottom: -8px;
    width: 100px;
}
.using-the-program2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    background-repeat: no-repeat;
    background-position: top -6px right -10px;
    background-size: 100px auto;
    padding: 20px;
}
.using-the-program3 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
    background-repeat: no-repeat;
    background-position: top -6px left -10px;
    background-size: 100px auto;
    padding: 20px 20px 3px 20px;
}
.using-the-program4 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
    background-repeat: no-repeat;
    background-position: top -6px right -10px;
    background-size: 100px auto;
    padding: 20px;
}
.using-the-program.arrow-bottom:after {
    content: " ";
    position: absolute;
    border-top: 25px solid #83156f;
    border-right: 25px solid transparent;
    border-left: 25px solid transparent;
    border-bottom: none;
    margin-top: 0px;
    margin-left: 28%;
}
.using-the-program1.arrow-bottom:after {
    margin-top: 0px;
}
.using-the-program3.arrow-bottom:after {
    margin-left: 26%;
    margin-top: 2px;
}
.using-the-program2.arrow-bottom:after {
    margin-left: 26%;
    margin-top: 20px;
}
.using-the-program4.arrow-bottom:after {
    margin-top: -21px;
}
h1 {
    margin-top: 30px;
}
h1 {
    font-size: 20px;
    color: #83156f;
    font-weight: normal;
    font-size: 1.5em;
}
h2 {
    font-size: 20px;
    color: #83156f;
    font-weight: normal;
    font-size: 1.5em;
}

.radio .checkmark:after {
    top: 5px;
    left: 5px;
    width: 50%;
    height: 50%;
    border-radius: 50%;
    background: #83156f;
}
.col1 {
    width: 50%;
    float: left;
}
.col2 {
    width: 50%;
    float: left;
}
.enroll_but {
    background-color: #fff;
    padding: 20px;
    font-size: 18px;
    display: block;
    float: left;
    font-weight: bold;
    text-decoration: none;
    margin-left: 30px;
    margin-top: 20px;
    color: #83156f !important;
    border: 2px solid #83156f;
    font-weight: bold;
    border-radius: 10px;
}
.col2 .enroll_but {
    float: right;
    margin-right: 20px;
}
.patients .eligibility td {
    background-color: #f2f2f2;
}
.patients .eligibility table {
    border-collapse: separate;
    border-spacing: 0;
}
.register-block {
    float: left;
    margin: 20px 10px;
    width: 100%;
}
.register-block a img {
    float: left;
    margin-right: 20px;
}
#tabs {
    float: left;
    border: 0;
}
.ui-tabs .ui-tabs-nav {
    border: 0;
}
.ui-tabs .ui-tabs-nav li {
    border: 0;
}
#hcp_post_content form p {
    float: none;
    width: auto;
}
.hcp th {
    text-align: left;
}
.hcp td,
th {
    padding: 6px;
}
.hcp table {
    border-collapse: separate;
    border-spacing: 0px;
    width: 100%;
}
.hcp th {
    text-align: left;
}
.ui-widget-header {
    background: #fff !important;
}
.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default {
    background: #fff !important;
}
.check {
    float: left;
}
.patients th {
    text-align: left;
    font-weight: normal;
}
.patients td,
th {
    padding: 6px;
}
.patients td.like-th {
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    background-repeat: repeat-x;
    color: #fff;
    text-align: left;
    font-weight: bold;
}
.patients td.like-td {
    background-color: #f2f2f2;
    color: #4d4d4f;
}
.patients th.like-td {
    background-color: #f2f2f2;
    color: #4d4d4f;
    background-image: none;
}
#tabs .ui-state-active a {
    outline: 0 !important;
}
.patients table {
    border-collapse: separate;
    width: 100%;
    overflow-x: auto;
    margin: 0;
}
.border-color {
    border: 2px solid #83156f;
    padding: 10px;
    display: block;
    float: left;
    margin-bottom: 20px;
}
#tabs-1 .border-color {
    border: 0;
    padding: 0;
    margin-bottom: 20px;
    margin-top: 20px;
}
#tabs-3 .border-color {
    border: 0;
    padding: 0;
    margin-bottom: 20px;
    margin-top: 20px;
}
table {
}
table.eligibility {
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 20px;
    padding: 15px;
    background-color: #f2f2f2;
    width: 97%;
}
table.eligibility td {
    background-color: #f2f2f2;
}

.right-top {
    float: left;
    margin-top: 20px;
    color: #000;
    padding-right: 20px;
}
.right-top a {
    color: #000 !important;
    font-weight: bold;
    line-height: 25px;
}
.border-right {
    border-right: 2px solid #000;
    margin-right: 20px;
    margin-bottom: 10px;
}
.right-top a {
    color: #83156f;
    text-decoration: none;
}
#header-hcp #nav li a:hover {
    background-color: #83156f;
    text-decoration: none;
    border: 1px solid #fff !important;
    color: #fff;
}
.hcp #navsubmenu li a:hover {
    background-color: #83156f;
    text-decoration: none;
    border: 1px solid #fff !important;
    color: #fff;
}
#tabs .ui-state-active a {
    background-color: #fff;
    text-decoration: none;
    border-bottom: 2px solid #83156f !important;
}
.hcp #tabs li a:hover {
    background-color: #fff;
    text-decoration: none;
    border-bottom: 2px solid #83156f !important;
}
.ui-tabs .ui-tabs-nav {
    height: auto;
    border-bottom: 1px solid #ddd;
}
.ui-tabs .ui-tabs-nav .ui-tabs-anchor {
    background: #fff;
    padding-left: 40px !important;
    padding-right: 40px !important;
    border: 0 !important;
    font-family: "AvenirNextLTW01-Regular" !important;
    font-size: 16px;
}
#home-container h1 {
    font-size: 25px;
}
#home-container-patients {
    width: 100%;
    display: block;
    float: left;
    margin-bottom: 40px;
    margin-top: 40px;
}

#home-container-hcp {
    width: 100%;
    display: block;
    float: left;
    margin-bottom: 40px;
}
#home-container-hcp img {
    border: 2px solid #83156f;
    width: 100%;
}
#header-patients #nav li a:hover {
    background-color: #83156f;
    text-decoration: none;
    border: 1px solid #fff !important;
    color: #fff;
}
#nav:hover li.selected a {
    border-radius: 5px;
}
ul.submenuitems li a:hover {
    border-radius: 0px;
}

.eligibility .col-lg-4 {
    margin-right: 10px;
    width: 32.6%;
}

.eligibility ul {
    margin-bottom: 0;
}
.eligibility ul ul {
    margin-top: 7px;
}
.eligibility .box-drug ul {
    margin-bottom: 0;
}
.box-drug strong {
    color: #83156f;
}

.patients .box-drug strong {
    color: #83156f;
}
.hcp ul li span {
    color: #4d4d4f;
}
span .bluetext {
    color: #83156f;
}
.patients ul li span {
    color: #4d4d4f;
}

.title-box {
    width: 100%;
    display: block;
    background-color: #6163ae;
    color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    float: left;
    font-size: 16px;
    font-weight: bold;
}
.hcp .title-box {
    width: 100%;
    display: block;
    background-color: #83156f;
    color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    float: left;
}
.content-box {
    background-color: #f6f5fb;
    display: block;
    float: left;
    margin-top: 10px;
    min-height: 80px;
    padding: 10px 20px;
    width: 100%;
}
.eligibility .col-lg-6 {
    margin-right: 10px;
    width: 49.4%;
}
.using1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    background-repeat: no-repeat;
    color: #fff;
    height: 150px;
    margin-top: 30px;
    padding-left: 50px;
    padding-right: 20px;
    padding-top: 30px;
    text-align: left;
    width: 662px;
}

.using2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    background-repeat: no-repeat;
    color: #fff;
    height: 450px;
    margin-top: 10px;
    padding-left: 50px;
    padding-top: 30px;
    text-align: left;
    width: 662px;
    padding-right: 120px;
}

.using3 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
    background-repeat: no-repeat;
    color: #fff;
    height: 200px;
    margin-top: 10px;
    padding-left: 50px;
    padding-right: 20px;
    padding-top: 20px;
    text-align: left;
    width: 662px;
}

.using4 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
    background-repeat: no-repeat;
    color: #fff;
    height: 300px;
    margin-top: 10px;
    padding-left: 50px;
    padding-right: 110px;
    padding-top: 35px;
    text-align: left;
    width: 662px;
}
.using4 img {
    display: none;
}
.using4 ul {
    margin-left: 0px;
    color: #fff;
    font-size: 15px;
    margin-top: 20px;
}
.padding {
    display: block;
    float: left;
    margin-left: 160px;
}

.using5 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
    background-repeat: no-repeat;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    height: 195px;
    margin-top: 10px;
    padding-left: 50px;
    padding-right: 70px;
    padding-top: 20px;
    text-align: left;
    width: 662px;
}

.using1-hcp {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
    background-repeat: no-repeat;
    background-position: left;
    height: 130px;
    margin-top: 10px;
    padding-left: 110px;
    padding-right: 100px;
    padding-top: 30px;
    text-align: left;
    width: 662px;
    color: #fff;
}
.using2-hcp {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
    background-repeat: no-repeat;
    background-position: left;
    height: 400px;
    margin-top: 10px;
    padding-left: 110px;
    padding-right: 120px;
    padding-top: 20px;
    text-align: left;
    width: 662px;
    color: #fff;
}
.using2-hcp a {
    color: #fff !important;
}
.using3-hcp {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
    background-repeat: no-repeat;
    color: #fff;
    font-size: 16px;
    height: 160px;
    margin-top: 10px;
    padding-left: 50px;
    padding-right: 20px;
    padding-top: 30px;
    text-align: left;
    width: 662px;
}

.using4-hcp {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
    background-repeat: no-repeat;
    color: #fff;
    font-size: 16px;
    height: 170px;
    margin-top: 10px;
    padding-left: 20px;
    padding-right: 110px;
    padding-top: 20px;
    text-align: left;
    width: 662px;
}
label.ssn {
    margin-bottom: 20px !important;
}
.messages-popupx {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.messages-popupx .popup-box {
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 5px 5px #555;
    margin: 0 auto;
    width: 800px;
    padding: 20px;
    position: relative;
}
.orange {
    color: #83156f;
    font-weight: bold;
}
.content-box2 {
    display: block;
    float: left;
    min-height: 160px;
    margin-top: 10px;
    width: 100%;
    margin-bottom: 30px;
}
.help .col-md-2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
    background-repeat: no-repeat;
    color: #fff;
    font-size: 40px;
    font-weight: bold;
    height: 121px;
    padding-left: 35px;
    text-align: left;
    margin-top: 10px;
}

.help .col-md-3 {
    color: #83156f;
    font-size: 22px;
    padding-top: 20px;
    font-weight: normal;
}
.help .col-md-7 {
    color: #83156f;
    font-size: 14px;
    font-weight: bold;
    padding-right: 55px;
    padding-top: 20px;
}
.patients .help .col-md-7 {
    color: #83156f;
    font-size: 19px;
    font-weight: normal;
    padding-right: 15px;
    padding-top: 20px;
    margin-left: 20px;
}

.patients .help .col-md-3 span {
    font-size: 22px;
    font-weight: normal;
}
.patients .help .col-md-3 span.small-p {
    font-size: 16px;
    font-weight: normal;
}
.help .col-md-3 strong {
    font-size: 20px;
    font-weight: bold;
}
#provider-eligibility h2 {
    font-size: 1.25em;
    color: #00759f;
}
.using-hcp-box table td.first {
    width: 40px;
}
.using-hcp-box img {
    margin-left: -30px;
    margin-top: -28px;
    width: 100px;
}

.agree_form label {
    text-align: left;
    width: 100%;
}
h2.blue {
    color: #00759f;
}
#provider-eligibility h3 {
    font-size: 1em;
    color: #00759f;
    font-weight: normal;
}
.eligibility .help ul {
    color: #83156f;
}
.eligibility .help ul li span {
    color: #83156f;
}
.help .col-md-2 span.d1 {
    float: left;
    font-size: 18px;
    padding-top: 35px;
}
.help .col-md-2 span.d2 {
    float: left;
    font-size: 35px;
    padding-top: 30px;
}
.find_pass input[type="text"] {
    max-width: 100%;
    width: 100%;
    float: left;
    /* margin-right: 20px; */
}
.hcp .nav li,
.hcp .submenu .nav li {
    width: 185px;
}
#provider-eligibility .circle1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
    background-repeat: no-repeat;
    background-size: 105px 105px;
    padding-left: 125px;
    min-height: 105px;
    padding-right: 20px;
    margin-bottom: 20px;
}
#provider-eligibility .circle2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
    background-repeat: no-repeat;
    background-size: 105px 105px;
    padding-left: 125px;
    min-height: 105px;
    padding-right: 20px;
    margin-bottom: 20px;
}
#provider-eligibility p {
    margin-bottom: 20px;
}
#provider-eligibility .help ul {
    display: block;
    padding-left: 20px;
}
.using-hcp-box {
    background-color: #f4f4fa;
    color: #83156f;
    padding: 20px 10px 8px 0;
    border-radius: 30px;
    font-size: inherit;
    display: block;
    clear: both;
    margin-bottom: 50px;
    margin-top: 30px;
    width: 560px;
    font-weight: bold;
    padding-left: 0;
    margin-left: 10px;
}
.border {
    border: 1px solid #dee2e6 !important;
}
.using-hcp .title {
    color: #00759f;
    background-color: transparent;
    width: auto;
    font-family: "Avenir Next LT W01 Bold";
}
.using-hcp span {
    color: #83156f !important;
}
.using-hcp ul {
    padding-left: 1rem;
    line-height: 1.3;
}
.using-hcp ul li ul li {
    list-style: circle !important;
}
.using-hcp ul li ul li:before {
    display: none;
}
.using-hcp-box table {
    border-collapse: separate;
    border-spacing: 0px;
    width: 100%;
    font-size: inherit;
    margin-bottom: 20px;
}
.using-hcp-box table td {
    background-color: transparent;
    border: 0;
    vertical-align: top;
    padding: 2px !important;
    color: #4d4d4f;
    font-weight: bold;
}
.using-the-program .using-hcp-box table td {
    background-color: transparent;
    border: 0;
    vertical-align: top;
    padding: 2px !important;
    color: #83156f;
    font-weight: bold;
}
.using-hcp-box table {
    margin: 0;
}
.using-hcp-box2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    background-repeat: no-repeat;
    background-position: top -7px right -11px;
    background-size: 110px auto;
    padding: 20px;
}
.using-hcp-box4 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
    background-repeat: no-repeat;
    background-position: top -9px right -11px;
    background-size: 118px auto;
    padding: 10px 10px 0 10px;
    min-height: 100px;
}
.using-hcp-box4 p {
    text-align: center;
    padding-right: 96px;
}
.using-hcp-box td {
    background-color: transparent;
    border: 0;
    vertical-align: top;
    padding: 2px !important;
    color: #83156f;
}
.using-hcp-box.arrow-bottom:after {
    content: " ";
    position: absolute;
    border-top: 25px solid #f4f4fa;
    border-right: 25px solid transparent;
    border-left: 25px solid transparent;
    border-bottom: none;
    margin-left: 22%;
}
.using-hcp-box4:after {
    margin-top: -22px;
}
.using-hcp-box2.arrow-bottom:after {
    margin-top: 20px;
    margin-left: 22%;
}
.title-box2 {
    width: 100%;
    display: block;
    background-color: #b4bf34;
    color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    text-transform: uppercase;
    background-size: cover;
}
.title-box2-drug {
    width: 100%;
    display: block;
    color: #fff;
    text-transform: uppercase;
    padding-top: 15px;
    padding-bottom: 10px;
    text-align: center;
    text-transform: uppercase;
    height: 57px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-repeat: no-repeat;
    background-position: center;
    font-size: 18px;
    background-size: cover;
}
.hcp .title-box2-drug {
    width: 100%;
    display: block;
    color: #fff;
    text-transform: uppercase;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    text-transform: uppercase;
    height: 57px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-repeat: no-repeat;
    background-position: center;
    font-size: 18px;
    background-size: cover;
}
.title-box2-inf {
    width: 100%;
    display: block;
    color: #fff;
    text-transform: uppercase;
    padding-top: 15px;
    padding-bottom: 10px;
    text-align: center;
    text-transform: uppercase;
    height: 57px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-repeat: no-repeat;
    background-position: center;
    font-size: 18px;
    margin-top: 20px;
    background-size: cover;
}
.home h1 {
}
.read-more {
    color: #0071d1;
    text-decoration: none;
}
.isi {
    width: 100%;
    display: block;
    float: left;
    margin-top: 50px;
    margin-bottom: 30px;
}
p.fax span {
    padding-top: 5px;
    display: block;
}
.see-more-isi {
    /* background-image:url(../images/see-sag.png);*/
    background-repeat: no-repeat;
    background-position: left;
    padding-left: 15px;
    color: #fff;
    text-decoration: none;
}
h2.isi {
    font-size: 16px;
    margin-top: 20px;
}
.patients h2.isi {
}
.right-isi {
    float: right;
}
a {
    color: #458ec1;
}
.patients a {
    color: #83156f;
}

.footer .privacy a {
    color: #fff;
    text-decoration: none;
}
.footer .float-right {
    padding-left: 130px;
}
.footer .float-right p {
    width: 100%;
    float: left;
}
.footer {
    width: 100%;
    display: block;
    float: left;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #83156f;
    min-height: 170px;
    color: #fff;
}

.fixed-footer {
    position: absolute;
    bottom: 0;
}
.header-isi {
    background-color: #83156f;
    color: #fff;
    padding-bottom: 10px;
    padding-top: 10px;
}
.ui-widget {
    font-size: 14px !important;
}
.patients .header-isi {
}
.see-more-isi {
    float: right;
}
.isi-title {
    float: left;
}

::selection {
    background: #b3d4fc;
    text-shadow: none;
}
.hcp .user-area .size {
    display: none;
}

/*
  * A better looking default horizontal rule
  */

hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
}

/*
  * Remove the gap between images and the bottom of their containers: h5bp.com/i/440
  */

img {
    vertical-align: middle;
}

/*
  * Remove default fieldset styles.
  */

fieldset {
    border: 0;
    margin: 0;
    padding: 0;
}

/*
  * Allow only vertical resizing of textareas.
  */

textarea {
    resize: vertical;
}

/* ==========================================================================
  Chrome Frame prompt
  ========================================================================== */

.chromeframe {
    margin: 0.2em 0;
    background: #ccc;
    color: #000;
    padding: 0.2em 0;
}

/* ==========================================================================
  Author's custom styles
  ========================================================================== */

/* ==========================================================================
  Helper classes
  ========================================================================== */
/*
  * Image replacement
  */

.ir {
    background-color: transparent;
    border: 0;
    overflow: hidden;
    /* IE 6/7 fallback */
    *text-indent: -9999px;
}

.ir:before {
    content: "";
    display: block;
    width: 0;
    height: 150%;
}

/*
  * Hide from both screenreaders and browsers: h5bp.com/u
  */

.hidden {
    display: none !important;
    visibility: hidden;
}

/*
  * Hide only visually, but have it available for screenreaders: h5bp.com/v
  */

.visuallyhidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

/*
  * Extends the .visuallyhidden class to allow the element to be focusable
  * when navigated to via the keyboard: h5bp.com/p
  */

.visuallyhidden.focusable:active,
.visuallyhidden.focusable:focus {
    clip: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    position: static;
    width: auto;
}

/*
  * Hide visually and from screenreaders, but maintain layout
  */

.invisible {
    visibility: hidden;
}

/*
  * Clearfix: contain floats
  *
  * For modern browsers
  * 1. The space content is one way to avoid an Opera bug when the
  *    \`contenteditable\` attribute is included anywhere else in the document.
  *    Otherwise it causes space to appear at the top and bottom of elements
  *    that receive the \`clearfix\` class.
  * 2. The use of \`table\` rather than \`block\` is only necessary if using
  *    \`:before\` to contain the top-margins of child elements.
  */

.clearfix:before,
.clearfix:after {
    content: " "; /* 1 */
    display: table; /* 2 */
}

.clearfix:after {
    clear: both;
}

/*
  * For IE 6/7 only
  * Include this rule to trigger hasLayout and contain floats.
  */

.clearfix {
    *zoom: 1;
}

/* ==========================================================================
  EXAMPLE Media Queries for Responsive Design.
  Theses examples override the primary ('mobile first') styles.
  Modify as content requires.
  ========================================================================== */

@media only screen and (min-width: 35em) {
    /* Style adjustments for viewports that meet the condition */
}

@media print, (min-resolution: 120dpi) {
    /* Style adjustments for high resolution devices */
}

/* ==========================================================================
  Jquery Modal.
  
  ========================================================================== */
.modal {
    background-color: #fff;
    display: none;
    width: 350px;
    padding: 15px;
    text-align: left;
    border: 2px solid #333;
    -moz-border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-box-shadow: 0 0 50px #ccc;
    -webkit-box-shadow: 0 0 50px #ccc;
}

/* ==========================================================================
  Print styles.
  Inlined to avoid required HTTP connection: h5bp.com/r
  ========================================================================== */

@media print {
    * {
        background: transparent !important;
        color: #000 !important; /* Black prints faster: h5bp.com/s */
        box-shadow: none !important;
        text-shadow: none !important;
    }
    a,
    a:visited {
        text-decoration: underline;
    }
    a[href]:after {
        content: " (" attr(href) ")";
    }
    abbr[title]:after {
        content: " (" attr(title) ")";
    }

    .ir a:after,
    a[href^="javascript:"]:after,
    a[href^="#"]:after {
        content: "";
    }

    pre,
    blockquote {
        border: 1px solid #999;
        page-break-inside: avoid;
    }

    thead {
        display: table-header-group;
    }

    tr,
    img {
        page-break-inside: avoid;
    }

    img {
        max-width: 100% !important;
    }

    @page {
        margin: 0.5cm;
    }

    p,
    h2,
    h3 {
        orphans: 3;
        widows: 3;
    }
    h2,
    h3 {
        page-break-after: avoid;
    }

    .googleMap .-sectionBody {
        width: 1300px;
        float: left;
    }
    .googleMap #pageContent h1,
    .googleMap .backList {
        display: none;
    }
    .googleMap .-sectionBody,
    .googleMap .resultDataMap {
        border: none;
    }

    .googleMap .resultDataMap .facilityListItem {
        float: left;
        width: 500px !important;
    }
    .googleMap .resultDataMap .colOne {
        float: left;
        width: 28px;
        display: block;
    }
    .googleMap .resultDataMap span.mapMarker {
        display: block;
        height: 38px;
        margin: 0 10px;
        width: 28px;
    }
    .googleMap .resultDataMap .colTwo {
        float: left;
        width: 85%;
        display: block;
        margin-left: 20px;
        margin-top: -15px;
    }
    .googleMap #facilityLocatorMap {
        float: left;
        height: 700px !important;
        width: 700px !important;
        dispaly: block;
    }
}
.progressbar {
    counter-reset: step;
    width: 100%;
    display: block;
    float: left;
    margin-top: 20px;
}
#container .progressbar li {
    list-style-type: none;
    width: 16.6%;
    float: left;
    font-size: 12px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    color: #7d7d7d;
    list-style: none;
    margin-left: 0;
}
.progressbar li:before {
    width: 30px;
    height: 30px;
    content: " ";
    counter-increment: step;
    line-height: 30px;
    border: 2px solid #7d7d7d;
    display: block;
    text-align: center;
    margin: 0 auto 10px auto;
    border-radius: 50%;
    background-color: white;
}
.progressbar li:after {
    width: 100%;
    height: 2px;
    content: "";
    position: absolute;
    background-color: #7d7d7d;
    top: 15px;
    left: -50%;
    z-index: -1;
}
.progressbar li:first-child:after {
    content: none;
}
.progressbar li.active {
    color: #83156f;
}
.progressbar li.active:before {
    background-color: #83156f;
    border-color: #83156f;
    color: #fff;
}
.progressbar li.active + li:after {
    background-color: #83156f;
}

.progressbar li.active {
    color: #83156f;
}
.progressbar li.active:before {
    background-color: #83156f;
    border-color: #83156f;
    color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
    background-repeat: no-repeat;
    background-size: 15px;
    background-position: center;
}
.progressbar li.active + li:after {
    /* background-image: url(../images/g.jpg);*/
    background-repeat: repeat-x;
}
.progressbar li.current:before {
    background-color: #83156f;
    border-color: #83156f;
    color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
    background-repeat: no-repeat;
    background-size: 15px;
    background-position: center;
}

.form_error_message {
    color: #990000;
}

.genericError {
    color: #990000;
}
.top-mobile {
    display: none;
}
@media all and (min-width: 320px) and (max-width: 320px) {
    table {
        margin: 20px 0px;
    }
}
@media all and (min-width: 320px) and (max-width: 481px) {
    .hcp button {
        float: left;
    }
}
p.date-mobil {
    display: none;
}
@media all and (min-width: 320px) and (max-width: 767px) {
    .desktop {
        display: none;
    }
    .mobile {
        display: block;
    }
    .call {
        float: left;
        width: 100%;
    }
    .fax {
        float: left;
        width: 100%;
    }
    .left_text {
        width: 100%;
        float: left;
    }
    .right_text {
        width: 100%;
        float: left;
        padding: 20px;
        box-shadow: 0 0 7px;
        margin-top: 40px;
    }
    .holidays-popup .popup-box {
        width: auto;
    }
    .footer .col-md-7 {
        width: 100% !important;
        margin-bottom: 20px;
    }
    .border-right {
        border: 0;
    }
    .right-top {
        padding-right: 0;
        width: 100%;
    }
    .top-header {
        width: 100%;
        float: left;
    }

    .content-buttons {
        float: left !important;
        width: 90% !important;
    }
    .title-home {
        background-color: #83156f;
        height: inherit;
        padding-top: 15px;
        padding-bottom: 15px;
        background-image: none;
        border-radius: 20px 20px 0px 0px;
    }
    p.date {
        display: none;
    }
    p.date-mobil {
        display: block;
    }
    p.date-mobil select {
        width: 57px !important;
    }
    #dob_month_box {
        width: 110px !important;
    }
    table.start_date {
        width: 100%;
    }
    table.start_date td {
        width: auto;
        float: left;
        clear: both;
    }
    .patients th {
        background-repeat: repeat;
    }
    #submit-skip {
        margin-top: 20px;
    }
    .pi_tab1 {
        width: 100% !important;
    }
    .ui-tabs .ui-tabs-panel {
        width: 100%;
        padding: 0 !important;
    }
    p.date-mobil .date-box {
        margin-right: 10px;
    }
    p.date-mobil label {
        width: 100%;
        float: left;
        text-align: left;
    }
    label {
        width: 100%;
        float: left;
        text-align: left;
        padding-bottom: 7px;
    }
    .formBox label {
        margin-bottom: 0;
    }
    #container #account_details ul li {
        list-style: none;
        padding-left: 0;
        margin-left: 0;
    }
    .ui-tabs .ui-tabs-nav {
        display: block !important;
    }
    .ui-tabs .ui-tabs-nav a {
        margin-top: 5px !important;
    }
    #account_details {
        float: left;
        margin-top: 10px;
    }
    .leftSpace {
        width: 100%;
        border: 0;
        margin-bottom: 0;
    }
    .rightSpace {
        width: 100%;
        border: 0;
        padding-left: 0;
        margin-bottom: 20px;
    }
    .alpha-filter table td {
        width: 30px;
        float: left;
    }
    .alpha-filter {
        float: left;
        background-color: #e8e8e8;
    }
    .patients td.like-td {
        text-align: center !important;
        padding: 10px !important;
        width: 40%;
    }
    .patients td.like-th {
        padding: 10px !important;
        width: 60%;
    }
    .patients td.like-th {
        background-repeat: repeat;
    }
    p.nothave-field label {
        width: 90%;
    }
    p.nothave-field-2 label {
        width: 90%;
    }
    .top a {
        width: 100%;
        margin-bottom: 1px;
    }
    .responsive-button {
        cursor: pointer;
        margin-top: 20px;
        background-color: #83156f;
        border: 1px solid #458ec1;
        font-size: 16px;
        padding: 10px 14px 10px 15px;
        margin-bottom: 0px !important;
        color: #fff;
        width: 100%;
    }
    .responsive-button-submenu {
        width: 100%;
    }
    #nav {
        /* display: none; */
    }
    .nav > li > a {
        width: 100%;
        display: block;
        float: left;
        text-align: left;
    }
    .after-title {
        padding: 20px !important;
    }
    .five-cost {
        width: 100%;
        margin-bottom: 20px;
    }
    .five-cost .col-xs-10 {
        width: 70%;
    }
    .five-cost span {
        padding-right: 0;
        display: block;
    }

    .col2 {
        width: 100%;
        float: left;
    }
    .col1 {
        width: 100%;
        float: left;
    }
    .radio {
        line-height: 20px !important;
    }
    .cost2 {
        padding-left: 0px;
    }

    .find_patient .select_container {
        width: 100%;
        margin-bottom: 20px;
        margin-right: 0;
    }
    .select_container select {
        width: 90%;
        max-width: 100%;
    }
    .find_patient input[type="text"] {
        max-width: 100%;
        width: 100%;
        margin-bottom: 20px;
    }
    .col-sm-12.col-md-12 {
        width: 100%;
        float: left;
    }
    input[type="text"],
    input[type="password"] {
        width: 100%;
    }
    .patients .button.enroll {
        display: block;
        float: none;
        margin: 0 auto;
        font-family: "Avenir Next LT W01 Bold";
    }
    .patients .button.account {
        display: block;
        float: none;
        margin: 0 auto;
        margin-top: 20px;
        font-family: "Avenir Next LT W01 Bold";
    }
    .find_patient {
        width: 100%;
        float: left;
        margin-bottom: 20px;
    }
    .hcp .nav li,
    .submenu .nav li {
        width: 100%;
    }
    .hcp .nav li,
    .submenu .nav li a {
        width: 100%;
    }
    .five-cost img {
        margin-bottom: 50px;
    }
    .nav li {
        float: left;
        width: 100%;
    }
    .text-enlarger {
        width: 260px;
    }
    .top-header {
        padding-top: 20px;
    }
    .title {
        width: 100%;
    }
    .text-enlarger-body {
        width: 100%;
    }
    .title-holder {
        width: 100%;
    }
    .size-link {
        display: inline-block;
        text-align: left;
        line-height: normal;
        text-decoration: none;
        background: none;
        width: 90%;
        height: auto;
        color: #000;
        border: 2px solid #f58425;
        padding: 15px;
        border-radius: 10px;
    }
    .responsive-button span {
        margin-left: 15px;
    }
    .responsive-button.active {
        margin-top: 20px;
        color: #fff;
    }
    .five-cost .center-col_1 img {
        margin: 0 auto;
        float: none;
        margin-bottom: 20px;
    }
    .five-cost .center-col_2 img {
        margin: 0 auto;
        float: none;
        margin-bottom: 20px;
    }
    .center-col_1 {
        width: 100%;
        float: left;
        text-align: center;
        padding: 0px;
        border-right: 0;
        margin-top: 20px;
    }
    .center-col_2 {
        width: 100%;
        float: left;
        text-align: center;
        padding: 0px;
        border-right: 0;
    }
    ul.submenuitems {
        position: relative;
    }
    ul.submenuitems li a {
        padding-left: 45px;
    }

    .ui-combobox {
        width: 70px;
    }
    #CombifyInput-dob-month {
        width: 60px;
    }
    #CombifyInput-dob-day {
        width: 60px;
    }
    #CombifyInput-dob-year {
        width: 60px;
    }
    .top {
        display: none;
    }
    #onetrust-banner-sdk.top {
        display: block;
    }
    .top-mobile {
        display: block;
        float: left;
        width: 100%;
    }
    .top-mobile .container {
        padding: 0;
    }
    .top-mobile a {
        color: #fff !important;
        background-color: #458ec1;
        padding: 10px;
        display: block;
        float: left;
        text-decoration: none;
        font-size: 15px;
        text-align: center;
        min-height: 80px;
    }
    .top-mobile a.active {
        color: #4d4d4f !important;
        background-color: #f4f4f4;
        display: block;
        float: left;
        text-decoration: none;
        font-size: 15px;
        border: 1px solid #d8d8d8;
    }
    .top-mobile a {
        width: 40%;
        display: block;
        float: left;
        padding-top: 14px;
    }
    .top-mobile a.hcp-tab {
        width: 60%;
        display: block;
        float: left;
        padding-top: 10px;
    }
    .right-top a {
        width: 100%;
        float: left;
    }
    .hide-mobil {
        display: none;
    }
    .responsive-button-submenu {
        cursor: pointer;
        margin-top: 20px;
        background: #83156f;
        color: #ffffff;
        font-size: 16px;
        padding: 10px 14px 10px 15px;
        margin-bottom: 0px !important;
        margin-right: 5px;
        border: 1px solid #606384 !important;
    }
    .hcp #navsubmenu li a:hover {
        background-color: #83156f;
        text-decoration: none;
        border: 1px solid #606384 !important;
        color: #fff;
    }
    .responsive-button-submenu span {
        margin-left: 15px;
    }
    .responsive-button-submenu.active {
        margin-top: 20px;
        border: 1px solid #606384 !important;
    }

    .submenu li a {
    }

    .nav a {
    }
    .nav li {
        margin-bottom: 0px !important;
    }
    .patients .nav .selected a {
    }
    .hcp .nav .selected a {
    }
    .nav > li > a {
        padding: 10px 45px !important;
    }
    #header {
        margin-bottom: 0px;
        padding: 0 !important;
    }
    #header-patients #nav li a:hover {
    }
    #header-hcp #nav li a:hover {
    }
    .right-top {
        float: left;
        margin-bottom: 10px;
    }
    table.patient-list {
        border-collapse: separate;
        border-spacing: 2px;
        display: block;
        overflow-x: auto;
        width: 100%;
    }
    #home-container {
        margin-top: 20px;
        margin-bottom: 25px;
        padding: 10px 10px 30px 10px;
    }
    #home-container-patients {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    #home-container-hcp {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .createaccount {
        float: left;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .date-box {
        margin-top: 5px;
        float: none;
    }
    #container .progressbar li {
        color: #ffffff;
    }
    .eligibility .col-lg-6 {
        width: 100%;
    }
    .scrollableArea {
        width: 100% !important;
    }
    .submenu .nav {
        width: 100%;
    }
    .eligibility .col-lg-4 {
        width: 100%;
    }
    .hcp-popup .popup-box {
        width: 90%;
    }
}

@media all and (min-width: 320px) and (max-width: 500px) {
    .patients .button.enroll {
        float: none !important;
        margin: 0 auto !important;
        display: block;
        margin-top: 10px !important;
    }
    .patients .button.account {
        float: none !important;

        margin: 0 auto !important;
        display: block;
        margin-top: 20px !important;
    }
}

@media all and (min-width: 768px) and (max-width: 990px) {
    .right-top {
        margin-top: 0;
        margin-bottom: 20px;
    }
    .patients .button.enroll {
        float: none;
        display: inline-block;
    }
    .patients .button.account {
        margin-right: 0px !important;
        float: none;
        display: inline-block;
    }
    .patients .button {
        float: none;
        width: 230px;
    }
    .eligibility .col-lg-6 {
        width: 100%;
    }
    .eligibility .col-lg-4 {
        width: 100%;
    }
}
@media all and (min-width: 320px) and (max-width: 481px) {
    a.logo img {
        max-width: 100%;
    }
    div.container {
        width: 100%;
    }
    .hcp button {
        float: left;
    }
    .padding {
        margin-left: 0;
    }
}
.using4 .padding {
    margin-left: 17px;
}
.dont-break-out {
    /* These are technically the same, but use both */
    overflow-wrap: break-word;
    word-wrap: break-word;

    -ms-word-break: break-all;
    /* This is the dangerous one in WebKit, as it breaks things wherever */
    word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;

    /* Adds a hyphen where the word breaks, if supported (No Blink) */
    -webkit-hyphens: auto;
    hyphens: auto;
}
@media all and (min-width: 320px) and (max-width: 750px) {
    .using4 .padding {
        margin-left: 15px;
    }
    .using4 ul {
        margin-left: 0px;
    }
    .using4 img {
        max-width: 30px;
    }
    ul.user-area {
        display: block;
    }
    .user-box {
        margin-top: 0px;
        float: left;
        padding: 10px;
    }
    #tabs .nav li {
        width: 100%;
    }
    .using1 img {
        display: none;
    }
    .using3 img {
        display: none;
    }
    .using4 img {
        display: none;
    }
    .using5 img {
        display: none;
    }
    .nav.user-area .icon-mm a.round-mm {
        width: 40px;
        text-align: center;
        float: right;
    }
    .using1-hcp {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
        background-repeat: no-repeat;
        margin-top: 10px;
        padding-left: 60px;
        padding-right: 40px;
        padding-top: 20px;
        text-align: left;
        width: 100%;
        background-position: top left;
        background-color: #83156f;
        border-radius: 10px;
        padding-bottom: 20px;
        border-radius: 20px;
        padding-bottom: 20px;
        float: left;
        height: auto;
    }
    .using3-hcp {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
        background-repeat: no-repeat;
        margin-top: 20px;
        padding-left: 60px;
        padding-right: 20px;
        padding-top: 20px;
        text-align: left;
        width: 100%;
        background-position: top left;
        background-color: #83156f;
        border-radius: 10px;
        padding-bottom: 20px;
        border-radius: 20px;
        padding-bottom: 20px;
        float: left;
        height: auto;
    }
    .using3-hcp img {
        display: none;
    }
    .using2-hcp {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
        background-repeat: no-repeat;
        margin-top: 20px;
        padding-left: 60px;
        padding-right: 50px;
        padding-top: 20px;
        text-align: left;
        width: 100%;
        background-position: top right;
        background-color: #83156f;
        border-radius: 10px;
        padding-bottom: 20px;
        border-radius: 20px;
        padding-bottom: 20px;
        float: left;
        height: auto;
    }
    .using4-hcp {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
        background-repeat: no-repeat;
        height: 140px;
        margin-top: 20px;
        padding-left: 60px;
        padding-right: 50px;
        padding-top: 20px;
        text-align: left;
        width: 100%;
        background-position: top right;
        background-color: #83156f;
        border-radius: 10px;
        padding-bottom: 20px;
        border-radius: 20px;
        padding-bottom: 20px;
        float: left;
        height: auto;
        margin-bottom: 20px;
    }

    .using1 {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
        background-repeat: no-repeat;
        margin-top: 10px;
        padding-left: 60px;
        padding-right: 40px;
        padding-top: 20px;
        text-align: left;
        width: 100%;
        background-position: top left;
        background-color: #83156f;
        border-radius: 10px;
        padding-bottom: 20px;
        border-radius: 20px;
        padding-bottom: 20px;
        float: left;
        height: auto;
    }
    .using3 {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
        background-repeat: no-repeat;
        margin-top: 20px;
        padding-left: 60px;
        padding-right: 20px;
        padding-top: 20px;
        text-align: left;
        width: 100%;
        background-position: top left;
        background-color: #83156f;
        border-radius: 10px;
        padding-bottom: 20px;
        border-radius: 20px;
        padding-bottom: 20px;
        float: left;
        height: auto;
    }

    .using2 {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
        background-repeat: no-repeat;
        margin-top: 20px;
        padding-left: 60px;
        padding-right: 50px;
        padding-top: 20px;
        text-align: left;
        width: 100%;
        background-position: top right;
        background-color: #83156f;
        border-radius: 10px;
        padding-bottom: 20px;
        border-radius: 20px;
        padding-bottom: 20px;
        float: left;
        height: auto;
    }
    .using4 {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
        background-repeat: no-repeat;
        height: 140px;
        margin-top: 20px;
        padding-left: 60px;
        padding-right: 50px;
        padding-top: 20px;
        text-align: left;
        width: 100%;
        background-position: top right;
        background-color: #83156f;
        border-radius: 10px;
        padding-bottom: 20px;
        border-radius: 20px;
        padding-bottom: 20px;
        float: left;
        height: auto;
        margin-bottom: 20px;
    }
    .using5 {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
        background-repeat: no-repeat;
        height: 140px;
        margin-top: 20px;
        padding-left: 60px;
        padding-right: 50px;
        padding-top: 20px;
        text-align: left;
        width: 100%;
        background-position: top right;
        background-color: #83156f;
        border-radius: 10px;
        padding-bottom: 20px;
        border-radius: 20px;
        padding-bottom: 20px;
        float: left;
        height: auto;
        margin-bottom: 20px;
    }
}

#header-patients #nav li a:hover {
    background-color: #83156f;
    text-decoration: none;
    color: #fff;
}
#header-patients #nav ul.submenuitems li a:hover {
    border: 0 !important;
    border-radius: 0px !important;
}
#nav li.selected a:hover {
    border-radius: 0px !important;
}
#header-hcp #nav li a:hover {
    background-color: #83156f;
    text-decoration: none;
    border: 1px solid #83156f !important;
    color: #fff;
}
.footer {
    font-weight: normal;
}
.isi h3 {
    font-weight: bold;
    font-size: 18px;
    color: #83156f;
}
.hcp .isi h3 {
    color: #83156f;
}
.hcp .footer {
    background-color: #83156f;
}
.hcp a {
    color: #83156f;
}
.hcp .isi p strong {
    color: #4d4d4f;
}

/* Adaugate last */

#navsubmenu {
    height: auto;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
}
#navsubmenu li {
    margin-left: 0 !important;
    background: #fff;
    margin-bottom: 0;
    width: auto;
    min-width: 160px;
}
#navsubmenu li a {
    color: rgba(0, 0, 0, 0.57);
    font-family: "AvenirNextLTW01-Regular";
    background: #fff;
    padding: 8px !important;
    padding-bottom: 10px !important;
    border: 0 !important;
}
#navsubmenu li.selected a {
    background: #fff;
    border-bottom: 2px solid #83156f !important;
}
.red {
    color: red;
}
.color-label label {
    color: #83156f;
    font-size: 16px !important;
    line-height: 20px !important;
    margin-bottom: 3px;
    width: 100%;
}
.color-label p {
    min-height: inherit;
}
p.alignright {
    min-height: inherit;
    text-align: right;
}
table.account th {
    background: #fff;
    font-size: 14px !important;
    color: rgba(0, 0, 0, 0.54);
    font-family: "Avenir Next LT W01 Bold";
    border-top: 2px solid #ddd;
    padding: 10px;
    border-bottom: 1px solid #ddd;
}
table.account th:first-child {
    padding-left: 20px;
}
table.account td:first-child {
    padding-left: 20px;
}
table.account td {
    font-size: 14px !important;
    padding: 10px;
}

table.account tr:nth-child(odd) td {
    background: #fff;
}

table.account tr:nth-child(even) td {
    background: #f2f2f2;
}

button.save {
    background: #fff;
    border-radius: 5px;
    margin-right: 0;
}
button.cancel {
    background: #fff;
    border-radius: 5px;
}
.info {
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: block;
    padding: 20px;
    background: #fff;
    padding-top: 10px;
    padding-bottom: 5px;
    margin-bottom: 10px;
}
.inner-drop {
    position: relative;
}

#dropdown {
    box-shadow: 0px 3px 8px 2px #b5b5b5;
    border-radius: 5px;
    background: #fff;
    position: absolute;
    top: 40px;
    left: 0;
    width: 240px;
    font-size: 15px;
}
#dropdown-2 {
    box-shadow: 0px 3px 8px 2px #b5b5b5;
    border-radius: 5px;
    background: #fff;
    position: absolute;
    top: 40px;
    left: 0;
    width: 300px;
    font-size: 15px;
}
#dropdown p {
    padding: 15px;
    margin-bottom: 0;
    background: #fff;
}
#dropdown-2 p {
    padding: 15px;
    margin-bottom: 0;
    background: #fff;
}
p.grey {
    background: #f5f5f5 !important;
}
#dropdown .checkbox .checkmark {
    top: 4px;
}
#dropdown-2 .checkbox .checkmark {
    top: 4px;
}
#dropdown-2 label {
    color: #4d4d4f !important;
    font-size: 14px !important;
}
.inner-drop select {
    width: 100%;
    max-width: inherit;
}
.space {
    width: 100%;
    display: inline-block;
    margin-bottom: 20px;
}
.user-box {
    background-color: #fff;
    padding: 15px;
    width: 300px;
    box-shadow: 0px 3px 8px 2px #b5b5b5;
    top: 40px;
    text-align: left;
}
.line-user.acc {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
    background-repeat: no-repeat;
    background-position: left;
    background-size: 20px;
    padding-left: 40px;
    height: 30px;
    margin-bottom: 10px;
    margin-left: 0;
    color: #4d4d4f;
}
.line-user.psw {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
    background-repeat: no-repeat;
    background-position: left;
    background-size: 20px;
    padding-left: 20px;
    padding-left: 40px;
    height: 30px;
    margin-bottom: 10px;
    margin-left: 0;
    color: #4d4d4f;
}
.line-user.out {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
    background-repeat: no-repeat;
    background-position: left;
    background-size: 20px;
    padding-left: 40px;
    height: 30px;
    margin-bottom: 10px;
    margin-left: 0;
    color: #4d4d4f;
}
.nav.user-area .icon-mm a {
    padding: 0px !important;
    margin-bottom: 8px;
    text-align: left;
    background: none;
    font-weight: normal;
    color: #4d4d4f;
}
.round-mm {
    width: 33px;
    height: 33px;
    border: 1px solid #6c757d;
    color: #83156f;
    padding: 2px;
    padding-top: 3px;
    font-size: 15px;
    margin-left: 0;
    margin-right: 5px;
}
.nav.user-area .icon-mm a.round-mm {
    padding: 2px !important;
    color: #83156f;
    font-weight: bold;
    border: 1px solid #6c757d !important;
}
.mm {
    padding-top: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #6c757d;
    margin-bottom: 10px;
}
.nav .icon-mm {
    width: auto;
}
.user-area a {
    color: #4d4d4f !important;
}
.nav.user-area .icon-mm a.round-mm {
    color: #83156f !important;
}
ul.submenuitems.user-box {
    left: auto;
    right: 0;
}
.font-bigger-size {
    font-size: 20px;
    font-weight: 500;
}
button.update {
    border: 0;
    padding: 0;
    text-decoration: underline;
}
#ui-datepicker-div {
    width: 300px;
}
.ui-datepicker td span,
.ui-datepicker td a {
    padding: 7px !important;
    text-align: center !important;
    text-decoration: none !important;
}
.show-indication {
    color: #00759f !important;
    cursor: pointer;
    margin-left: 25px;
    text-decoration: none;
}
.table-bordered {
    margin: 0;
}
.modal-header h3 {
    color: #83156f;
    font-size: 23px;
    font-weight: normal;
}
.modal-header {
    border-bottom: 0 !important;
}
.modal-body th {
    background: #f8c121;
    color: #fff;
}
.line-user.users {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
    background-repeat: no-repeat;
    background-position: left;
    background-size: 20px;
    padding-left: 40px;
    height: 30px;
    /* margin-left: 10px; */
    margin-bottom: 10px;
}
a.notif {
    display: block;
    float: right;
    /* padding: 7px; */
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 3px;
}
.notif {
    position: relative;
}
.notif img {
    max-width: 20px;
}
.notif small {
    background: #ff0000;
    border-radius: 15px;
    color: #fff;
    font-weight: bold;
    width: 18px;
    height: 18px;
    display: inline-block;
    line-height: 12px;
    font-size: 9px;
    text-align: center;
    margin-top: -5px;
    position: absolute;
    padding: 3px;
}
a.button.fltright {
    background-color: #fff;
    color: #83156f !important;
    border: 2px solid #83156f;
    border-radius: 7px;
    color: #fff;
    padding: 8px;
    padding-left: 15px;
    padding-right: 15px;
    text-decoration: none;
    width: auto;
    float: right;
    height: auto;
}
#fancybox-close:hover {
    background-color: #f0e3ed !important;
}
.patients .using-hcp-box table td {
    padding-right: 7px !important;
}
.patients .using-hcp-box table td a {
    text-decoration: none;
}
.no-box p {
    margin-bottom: 15px;
}
.pad-left {
    padding-left: 25px;
}

.checkbox {
    display: block;
    position: relative;
    padding-left: 25px;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    float: left;
    margin-top: 0;
}
.checkbox .checkmark {
    width: 15px;
    height: 15px;
}
.checkbox input {
    position: absolute;
    opacity: 0;
}

label.checkbox {
    text-align: left;
}
/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkmark {
}

/* When the checkbox button is checked, add a blue background */
.checkbox input:checked ~ .checkmark {
    background-color: #83156f;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}
.checkbox .checkmark {
    border-radius: 0;
}
/* Show the indicator (dot/circle) when checked */
.checkbox input:checked ~ .checkmark:after {
    display: block;
}

/* Style the indicator (dot/circle) */
.checkbox .checkmark:after {
    width: 12px;
    height: 12px;
    background-color: #83156f;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
    background-repeat: no-repeat;
}
.checkmark.error-check {
    border: 1px solid #ff0000 !important;
}
.error-msj {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
    padding: 20px;
}
.patients .page-alert .popup-box {
    max-width: 800px;
}
.pages {
    font-size: 13px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 40px;
    width: 100%;
    float: left;
}
.nav-left {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
    background-repeat: no-repeat;
    margin-right: 40px;
    color: #888;
    margin-top: 5px;
}
.nav-right {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
    background-repeat: no-repeat;
    margin-top: 5px;
}
.pages select {
    width: 50px;
    border-bottom: 1px solid #4d4d4f;
    padding-bottom: 3px;
}
.ui-widget {
    font-family: "AvenirNextLTW01-Regular" !important;
}
#home-container-patients img {
    width: 100%;
}
.hcp #home-container-patients {
    margin-bottom: 20px;
}
.deactivate-popup button.save {
    background: #ddd;
}
.activate-popup button.save {
    background: #ddd;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;;+EAE+E;;AAE/E;IACI,sCAAsC;IACtC,4CAAiE;IACjE;;;;6DAI4G;AAChH;AACA;IACI,sCAAsC;IACtC,4CAAiE;IACjE;;;;6DAI4G;AAChH;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,cAAc;AAClB;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,WAAW;IACf;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;;;;;IAKI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,cAAc;IACd,sCAAsC;IACtC,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,WAAW;AACf;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;AACd;AACA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,0DAA8C;IAC9C,4BAA4B;IAC5B,0BAA0B;IAC1B,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,iCAAiC;IACjC,oCAAoC;IACpC,6BAA6B;IAC7B,YAAY;IACZ,cAAc;IACd,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;AAChB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,sCAAsC;AAC1C;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,aAAa;IAEb,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,cAAc;AAClB;AACA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,eAAe;AACnB;AACA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,0DAAoD;AACxD;AACA;IACI,0DAAoD;AACxD;AACA;;IAEI,4BAA4B;IAC5B,4BAA4B;IAC5B,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;AAChC;AACA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,0DAA8C;AAClD;AACA;IACI,0DAAgD;AACpD;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;AACA;AACA;IACI,oBAAoB;AACxB;AACA;;;AAGA;AACA;IACI,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;;;IAGI,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,aAAa;IACb,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;AACA;AACA;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;AACA;AACA;IACI,oBAAoB;IACpB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,cAAc;AAClB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,sBAAsB;IACtB,eAAe;AACnB;AACA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,YAAY;IACZ,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,gCAAgC;AACpC;AACA,oEAAoE;AACpE;IACI,mBAAmB;AACvB;AACA;IACI,yDAAyD;IACzD,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;AACA;IACI,eAAe;IACf,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,UAAU;IACV,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;;;;GAIG;AACH;;IAEI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,0DAAgD;IAChD,4BAA4B;IAC5B,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;IACI,cAAc;AAClB;AACA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,WAAW;IACX,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,wDAAwD;IACxD,SAAS;IACT,aAAa;IACb,OAAO;IACP,WAAW;IACX,eAAe;IACf,QAAQ;IACR,MAAM;IACN,aAAa;AACjB;AACA;IACI,cAAc;IACd,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;;;IAGI,oCAAoC;AACxC;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;AACA;AACA;AACA;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA,+CAA+C;AAC/C;IACI,sBAAsB;AAC1B;;AAEA,4DAA4D;AAC5D;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,oEAAoE;AACpE;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA,iDAAiD;AACjD;IACI,cAAc;AAClB;AACA;AACA;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,6BAA6B;IAC7B,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,0DAA6C;IAC7C,4BAA4B;IAC5B,yCAAyC;IACzC,2BAA2B;IAC3B,aAAa;AACjB;AACA;IACI,0DAA6C;IAC7C,4BAA4B;IAC5B,wCAAwC;IACxC,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,0DAA6C;IAC7C,4BAA4B;IAC5B,yCAAyC;IACzC,2BAA2B;IAC3B,aAAa;AACjB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,oCAAoC;IACpC,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,2BAA2B;AAC/B;AACA;;;IAGI,2BAA2B;AAC/B;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,0DAA2C;IAC3C,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;AACA;AACA;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,iCAAiC;IACjC,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,iCAAiC;IACjC,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,2CAA2C;AAC/C;AACA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,2CAA2C;AAC/C;AACA;IACI,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,8BAA8B;IAC9B,oBAAoB;IACpB,iDAAiD;IACjD,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,iCAAiC;IACjC,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,0DAA2C;IAC3C,4BAA4B;IAC5B,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0DAA2C;IAC3C,4BAA4B;IAC5B,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,0DAA2C;IAC3C,4BAA4B;IAC5B,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0DAA2C;IAC3C,4BAA4B;IAC5B,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,0DAA2C;IAC3C,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0DAA+C;IAC/C,4BAA4B;IAC5B,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;AACA;IACI,0DAA+C;IAC/C,4BAA4B;IAC5B,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAA+C;IAC/C,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0DAA+C;IAC/C,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,0DAA2C;IAC3C,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,WAAW;IACX,wBAAwB;AAC5B;AACA;;IAEI,YAAY;AAChB;AACA;IACI,0DAA4C;IAC5C,4BAA4B;IAC5B,4BAA4B;IAC5B,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,0DAA4C;IAC5C,4BAA4B;IAC5B,4BAA4B;IAC5B,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,cAAc;IACd,6BAA6B;IAC7B,WAAW;IACX,sCAAsC;AAC1C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,6BAA6B;IAC7B,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,SAAS;AACb;AACA;IACI,0DAA6C;IAC7C,4BAA4B;IAC5B,yCAAyC;IACzC,2BAA2B;IAC3B,aAAa;AACjB;AACA;IACI,0DAA6C;IAC7C,4BAA4B;IAC5B,yCAAyC;IACzC,2BAA2B;IAC3B,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,oCAAoC;IACpC,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,0DAA8C;IAC9C,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,0DAA8C;IAC9C,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,0DAAgD;IAChD,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;AACA;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;AACA;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,0BAA0B;AAC9B;AACA;AACA;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;;AAMA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;;AAEA;;GAEG;;AAEH;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,aAAa;IACb,UAAU;AACd;;AAEA;;GAEG;;AAEH;IACI,sBAAsB;AAC1B;;AAEA;;GAEG;;AAEH;IACI,SAAS;IACT,SAAS;IACT,UAAU;AACd;;AAEA;;GAEG;;AAEH;IACI,gBAAgB;AACpB;;AAEA;;8EAE8E;;AAE9E;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;;8EAE8E;;AAE9E;;8EAE8E;AAC9E;;GAEG;;AAEH;IACI,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;IAChB,oBAAoB;KACpB,oBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,QAAQ;IACR,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;;GAEG;;AAEH;IACI,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;GAGG;;AAEH;;IAEI,UAAU;IACV,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;;;;;;;;;;GAUG;;AAEH;;IAEI,YAAY,EAAE,MAAM;IACpB,cAAc,EAAE,MAAM;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;;;GAGG;;AAEH;KACI,OAAQ;AACZ;;AAEA;;;;8EAI8E;;AAE9E;IACI,4DAA4D;AAChE;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;;8EAG8E;AAC9E;IACI,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;;;8EAG8E;;AAE9E;IACI;QACI,kCAAkC;QAClC,sBAAsB,EAAE,oCAAoC;QAC5D,2BAA2B;QAC3B,4BAA4B;IAChC;IACA;;QAEI,0BAA0B;IAC9B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,6BAA6B;IACjC;;IAEA;;;QAGI,WAAW;IACf;;IAEA;;QAEI,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;;;QAGI,UAAU;QACV,SAAS;IACb;IACA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,WAAW;IACf;IACA;;QAEI,aAAa;IACjB;IACA;;QAEI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;IACA;QACI,WAAW;QACX,WAAW;QACX,cAAc;IAClB;IACA;QACI,cAAc;QACd,YAAY;QACZ,cAAc;QACd,WAAW;IACf;IACA;QACI,WAAW;QACX,UAAU;QACV,cAAc;QACd,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,wBAAwB;QACxB,uBAAuB;QACvB,cAAc;IAClB;AACJ;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,0DAA0C;IAC1C,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;AAC/B;AACA;IACI,2CAA2C;IAC3C,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,0DAA2C;IAC3C,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;IACA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,SAAS;IACb;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,qBAAqB;IACzB;IACA;QACI,yBAAyB;QACzB,eAAe;QACf,iBAAiB;QACjB,oBAAoB;QACpB,sBAAsB;QACtB,gCAAgC;IACpC;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,WAAW;QACX,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,qBAAqB;IACzB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,SAAS;QACT,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,yBAAyB;IAC7B;IACA;QACI,6BAA6B;QAC7B,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,yBAAyB;QACzB,yBAAyB;QACzB,eAAe;QACf,4BAA4B;QAC5B,6BAA6B;QAC7B,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,4BAA4B;IAChC;IACA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,eAAe;QACf,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;;QAEI,WAAW;IACf;IACA;QACI,cAAc;QACd,WAAW;QACX,cAAc;QACd,sCAAsC;IAC1C;IACA;QACI,cAAc;QACd,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,sCAAsC;IAC1C;IACA;QACI,WAAW;QACX,WAAW;QACX,mBAAmB;IACvB;IACA;;QAEI,WAAW;IACf;IACA;;QAEI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,qBAAqB;QACrB,gBAAgB;QAChB,mBAAmB;QACnB,qBAAqB;QACrB,gBAAgB;QAChB,UAAU;QACV,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,cAAc;QACd,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;QACd,WAAW;QACX,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,yBAAyB;QACzB,aAAa;QACb,cAAc;QACd,WAAW;QACX,qBAAqB;QACrB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,yBAAyB;QACzB,yBAAyB;QACzB,cAAc;QACd,WAAW;QACX,qBAAqB;QACrB,eAAe;QACf,yBAAyB;IAC7B;IACA;QACI,UAAU;QACV,cAAc;QACd,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,UAAU;QACV,cAAc;QACd,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,4BAA4B;QAC5B,6BAA6B;QAC7B,iBAAiB;QACjB,oCAAoC;IACxC;IACA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,oCAAoC;QACpC,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,oCAAoC;IACxC;;IAEA;IACA;;IAEA;IACA;IACA;QACI,6BAA6B;IACjC;IACA;IACA;IACA;IACA;IACA;QACI,6BAA6B;IACjC;IACA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;IACA;IACA;IACA;IACA;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,4BAA4B;IAChC;IACA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,yBAAyB;QACzB,cAAc;QACd,2BAA2B;IAC/B;IACA;QACI,sBAAsB;;QAEtB,yBAAyB;QACzB,cAAc;QACd,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,qBAAqB;IACzB;IACA;QACI,4BAA4B;QAC5B,WAAW;QACX,qBAAqB;IACzB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iDAAiD;IACjD,yBAAyB;IACzB,qBAAqB;;IAErB,yBAAyB;IACzB,sEAAsE;IACtE,qBAAqB;IACrB,uCAAuC;IACvC,sBAAsB;;IAEtB,iEAAiE;IAGjE,qBAAqB;IACrB,aAAa;AACjB;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,WAAW;QACX,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,0DAA+C;QAC/C,4BAA4B;QAC5B,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,6BAA6B;QAC7B,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,YAAY;IAChB;IACA;QACI,0DAA+C;QAC/C,4BAA4B;QAC5B,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,6BAA6B;QAC7B,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,0DAA+C;QAC/C,4BAA4B;QAC5B,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,YAAY;IAChB;IACA;QACI,0DAA+C;QAC/C,4BAA4B;QAC5B,aAAa;QACb,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,0DAA+C;QAC/C,4BAA4B;QAC5B,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,6BAA6B;QAC7B,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,YAAY;IAChB;IACA;QACI,0DAA+C;QAC/C,4BAA4B;QAC5B,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,6BAA6B;QAC7B,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0DAA+C;QAC/C,4BAA4B;QAC5B,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,YAAY;IAChB;IACA;QACI,0DAA+C;QAC/C,4BAA4B;QAC5B,aAAa;QACb,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,0DAA+C;QAC/C,4BAA4B;QAC5B,aAAa;QACb,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,oBAAoB;IACpB,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,oCAAoC;IACpC,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA,kBAAkB;;AAElB;IACI,YAAY;IACZ,0BAA0B;IAC1B,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,sCAAsC;IACtC,gBAAgB;IAChB,uBAAuB;IACvB,+BAA+B;IAC/B,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,2CAA2C;AAC/C;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;IACd,0BAA0B;IAC1B,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,0BAA0B;IAC1B,sCAAsC;IACtC,0BAA0B;IAC1B,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,+GAA+G;IAC/G,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;AAEA;IAEI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,eAAe;AACnB;AACA;IAEI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,QAAQ;AACZ;AACA;IACI,QAAQ;AACZ;AACA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,YAAY;IAEZ,mCAAmC;IACnC,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,0DAA8C;IAC9C,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;AACA;IACI,0DAA6C;IAC7C,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;AACA;IACI,0DAAgD;IAChD,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,oCAAoC;AACxC;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,QAAQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,UAAU;IACV,0BAA0B;AAC9B;AACA;IACI,YAAY;AAChB;AACA;;IAEI,uBAAuB;IACvB,6BAA6B;IAC7B,gCAAgC;AACpC;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,SAAS;AACb;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,0DAA8C;IAC9C,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;IACjB,WAAW;IACX,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;AACA,+CAA+C;AAC/C;AACA;;AAEA,+DAA+D;AAC/D;IACI,yBAAyB;AAC7B;;AAEA,oEAAoE;AACpE;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA,iDAAiD;AACjD;IACI,cAAc;AAClB;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,0DAA+C;IAC/C,4BAA4B;AAChC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,0DAA6C;IAC7C,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,0DAA8C;IAC9C,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI,WAAW;IACX,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB","sourcesContent":["/*\r\n * HTML5 Boilerplate\r\n *\r\n * What follows is the result of much research on cross-browser styling.\r\n * Credit left inline and big thanks to Nicolas Gallagher, Jonathan Neal,\r\n * Kroc Camen, and the H5BP dev community and team.\r\n */\r\n\r\n/* ==========================================================================\r\n   Base styles: opinionated defaults\r\n   ========================================================================== */\r\n\r\n@font-face {\r\n    font-family: \"AvenirNextLTW01-Regular\";\r\n    src: url(\"Fonts/e9167238-3b3f-4813-a04a-a384394eed42.eot?#iefix\");\r\n    src: url(\"Fonts/e9167238-3b3f-4813-a04a-a384394eed42.eot?#iefix\") format(\"eot\"),\r\n        url(\"Fonts/2cd55546-ec00-4af9-aeca-4a3cd186da53.woff2\") format(\"woff2\"),\r\n        url(\"Fonts/1e9892c0-6927-4412-9874-1b82801ba47a.woff\") format(\"woff\"),\r\n        url(\"Fonts/46cf1067-688d-4aab-b0f7-bd942af6efd8.ttf\") format(\"truetype\"),\r\n        url(\"Fonts/52a192b1-bea5-4b48-879f-107f009b666f.svg#52a192b1-bea5-4b48-879f-107f009b666f\") format(\"svg\");\r\n}\r\n@font-face {\r\n    font-family: \"Avenir Next LT W01 Bold\";\r\n    src: url(\"Fonts/dccb10af-07a2-404c-bfc7-7750e2716bc1.eot?#iefix\");\r\n    src: url(\"Fonts/dccb10af-07a2-404c-bfc7-7750e2716bc1.eot?#iefix\") format(\"eot\"),\r\n        url(\"Fonts/14c73713-e4df-4dba-933b-057feeac8dd1.woff2\") format(\"woff2\"),\r\n        url(\"Fonts/b8e906a1-f5e8-4bf1-8e80-82c646ca4d5f.woff\") format(\"woff\"),\r\n        url(\"Fonts/890bd988-5306-43ff-bd4b-922bc5ebdeb4.ttf\") format(\"truetype\"),\r\n        url(\"Fonts/ed104d8c-7f39-4e8b-90a9-4076be06b857.svg#ed104d8c-7f39-4e8b-90a9-4076be06b857\") format(\"svg\");\r\n}\r\nstrong {\r\n    font-family: \"Avenir Next LT W01 Bold\";\r\n}\r\na strong {\r\n    color: #83156f;\r\n}\r\nb {\r\n    font-family: \"Avenir Next LT W01 Bold\";\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .small-login {\r\n        width: 100%;\r\n    }\r\n    .home-page-announcement .popup-box .close-button {\r\n        float: none;\r\n    }\r\n    .footer .float-right {\r\n        padding-left: 0;\r\n    }\r\n    .home-page-announcement .popup-box {\r\n        width: 90%;\r\n        height: 90%;\r\n    }\r\n}\r\n@media only screen and (max-width: 1024px) {\r\n    .home-page-announcement {\r\n        padding: 0;\r\n    }\r\n}\r\n\r\nhtml,\r\nbutton,\r\ninput,\r\nselect,\r\ntextarea {\r\n    color: #222;\r\n}\r\nhtml {\r\n    width: 100%;\r\n}\r\nbody {\r\n    font-size: 16px;\r\n    color: #4d4d4f;\r\n    font-family: \"AvenirNextLTW01-Regular\";\r\n    line-height: 23px;\r\n}\r\nheader {\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n}\r\na.logo {\r\n    float: left;\r\n}\r\n.noWrap,\r\n.nowrapTxt {\r\n    white-space: nowrap;\r\n}\r\n#submit-skip {\r\n    float: right;\r\n    margin-top: -20px;\r\n}\r\n.leftSpace {\r\n    border-right: 1px solid #000;\r\n    float: left;\r\n    width: 35%;\r\n    padding-right: 30px;\r\n    margin-bottom: 40px;\r\n}\r\np.dob label {\r\n    padding-bottom: 5px;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\np.dob input.datepicker {\r\n    width: 220px;\r\n}\r\n.rightSpace {\r\n    float: left;\r\n    padding-left: 40px;\r\n    /* padding-top: 20px; */\r\n    width: 40%;\r\n}\r\n.find_pass form {\r\n    width: 350px;\r\n    margin: 0 auto;\r\n    margin-bottom: 20px;\r\n}\r\n.find_pass label {\r\n    display: none;\r\n}\r\n\r\n.refnum {\r\n    width: 300px;\r\n}\r\n.refnum label {\r\n    display: none;\r\n}\r\ninput.datepicker {\r\n    background-image: url(../images/data-icon.png);\r\n    background-repeat: no-repeat;\r\n    background-position: right;\r\n    background-size: 27px;\r\n}\r\n#fancybox-close {\r\n    background: none;\r\n    color: #83156f !important;\r\n    background-color: #fff !important;\r\n    border: 2px solid #83156f !important;\r\n    border-radius: 7px !important;\r\n    padding: 7px;\r\n    display: block;\r\n    left: 0;\r\n    top: 0px;\r\n    margin-bottom: 20px;\r\n    width: auto;\r\n    float: left;\r\n    height: auto;\r\n    margin-top: 10px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    position: relative;\r\n    font-size: 16px;\r\n}\r\n#tabs-2 .border-color {\r\n    border: 0;\r\n    padding: 0;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n}\r\n.content-holder p {\r\n    width: 100%;\r\n    float: left;\r\n    font-size: 16px;\r\n}\r\ntable.eligibility select {\r\n    padding: 12px;\r\n    margin-top: 5px;\r\n    border-radius: 5px;\r\n    border: 1px solid #ddd;\r\n}\r\n.dob .error {\r\n    width: 100%;\r\n    font-size: 13px;\r\n}\r\n.apply-step-one-form p {\r\n    margin-bottom: 10px;\r\n}\r\n.underline {\r\n    text-decoration: underline;\r\n    display: block;\r\n    margin-bottom: 5px;\r\n}\r\n.search-div {\r\n    width: 100%;\r\n    float: left;\r\n    margin-bottom: 20px;\r\n}\r\n.user-box {\r\n    background-color: #f2f2f2;\r\n    padding: 10px;\r\n    width: 200px;\r\n}\r\n.links {\r\n    width: 100%;\r\n    display: block;\r\n    float: left;\r\n    margin-top: 10px;\r\n    margin-bottom: 7px;\r\n}\r\nul.user-area {\r\n    float: right;\r\n    width: auto;\r\n    padding-left: 20px;\r\n}\r\n.nav.user-area .icon-mm a {\r\n    margin-bottom: 0;\r\n    margin-top: 0;\r\n    font-family: \"AvenirNextLTW01-Regular\";\r\n}\r\n.nav.user-area .icon-mm {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n}\r\n.nav.user-area .icon-mm a {\r\n    padding: 0px !important;\r\n    margin-bottom: 8px;\r\n}\r\n.nav.user-area .icon-mm a.round-mm {\r\n    padding: 5px !important;\r\n    color: #83156f;\r\n}\r\n.grey {\r\n    background-color: #f2f2f2;\r\n    padding: 20px;\r\n    margin-bottom: 20px;\r\n    padding-top: 0;\r\n}\r\n.site-text-size {\r\n    margin-top: 5px;\r\n    float: right;\r\n    clear: both;\r\n}\r\n.site-text-size span {\r\n    display: block;\r\n    padding-top: 7px;\r\n    float: left;\r\n    padding-right: 5px;\r\n    color: #83156f;\r\n    font-size: 15px;\r\n    padding-top: 0;\r\n    line-height: 25px;\r\n}\r\n.site-text-sm {\r\n    font-size: 14px;\r\n    padding-top: 5px;\r\n}\r\n.site-text-md {\r\n    font-size: 18px;\r\n    padding-top: 3px;\r\n}\r\n.site-text-toggle.active {\r\n    color: #83156f;\r\n    border: 1px solid #83156f;\r\n}\r\n.site-text-lg {\r\n    font-size: 22px;\r\n    display: inline-block;\r\n    line-height: 22px;\r\n}\r\n.content-buttons p {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n.five-cost li {\r\n    margin-left: 17px !important;\r\n    margin-bottom: 0 !important;\r\n}\r\n.call {\r\n    float: left;\r\n    width: 70%;\r\n}\r\n.fax {\r\n    float: left;\r\n    width: 100%;\r\n    margin-bottom: 5px;\r\n}\r\n.shadow-box {\r\n    width: 100%;\r\n    display: block;\r\n    float: left;\r\n    margin-bottom: 30px;\r\n    padding: 20px;\r\n    -webkit-box-shadow: 0px 3px 8px 2px #b5b5b5;\r\n    box-shadow: 0px 3px 8px 2px #b5b5b5;\r\n}\r\n.section {\r\n    width: 100%;\r\n    display: block;\r\n    float: left;\r\n}\r\n.section h2 {\r\n    margin-top: 0;\r\n}\r\n.section label {\r\n    width: 95%;\r\n    text-align: left;\r\n    line-height: 20px !important;\r\n}\r\n.section input[type=\"text\"] {\r\n    width: 95%;\r\n    border: 1px solid #d8d8d8;\r\n    padding: 10px;\r\n    border-radius: 4px 4px 4px 4px;\r\n    padding-top: 15px;\r\n}\r\n.section button[type=\"reset\"] {\r\n    background-color: #fff;\r\n    border: 1px solid #d8d8d8 !important;\r\n    color: #4d4d4f;\r\n}\r\n.small-login {\r\n    width: 400px;\r\n    margin: 0 auto;\r\n    min-height: 200px;\r\n}\r\n.small-login label {\r\n    width: 100%;\r\n    text-align: left;\r\n    padding-bottom: 5px;\r\n}\r\n.small-login input[type=\"text\"],\r\n.small-login input[type=\"password\"] {\r\n    width: 100%;\r\n    max-width: 100%;\r\n}\r\n.clear {\r\n    width: 100%;\r\n    display: block;\r\n    height: 20px;\r\n    clear: both;\r\n}\r\n\r\n.section .select_container {\r\n    width: 95%;\r\n    border: 1px solid #d8d8d8;\r\n    padding: 10px;\r\n    border-radius: 4px 4px 4px 4px;\r\n    padding-top: 15px;\r\n}\r\n.section .select_container select {\r\n    max-width: 100%;\r\n    width: 100%;\r\n}\r\n.section p.date img {\r\n    display: none;\r\n}\r\n.section p {\r\n    min-height: 70px;\r\n}\r\n.enroll-form .section p {\r\n    min-height: inherit;\r\n}\r\n.section p.blue {\r\n    min-height: inherit;\r\n    color: #83156f;\r\n    padding-bottom: 15px;\r\n}\r\n.inner-label {\r\n    background: #fff;\r\n    display: block;\r\n    float: left;\r\n    margin-bottom: -14px;\r\n    padding: 7px;\r\n    margin-left: 5px;\r\n    padding-left: 5px;\r\n    position: relative;\r\n}\r\n#home-container p input {\r\n    max-width: 270px;\r\n    width: 270px;\r\n    padding: 10px;\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n    border: 1px solid #ddd;\r\n    font-size: 13px;\r\n}\r\n#home-container form p {\r\n    clear: both;\r\n    float: left;\r\n    width: 270px;\r\n    clear: none;\r\n    margin-right: 10px;\r\n}\r\n#patient-eligibility h3 {\r\n    font-weight: normal;\r\n    color: #83156f;\r\n    margin-top: 10px;\r\n}\r\n#patient-eligibility p {\r\n    margin-bottom: 20px;\r\n}\r\n#patient-eligibility .circle1 {\r\n    background-image: url(../images/circle1-patient.png);\r\n}\r\n#patient-eligibility .circle2 {\r\n    background-image: url(../images/circle2-patient.png);\r\n}\r\n#patient-eligibility .circle1,\r\n#patient-eligibility .circle2 {\r\n    background-repeat: no-repeat;\r\n    background-size: 105px 105px;\r\n    background-position: center left;\r\n    padding-left: 125px;\r\n    min-height: 105px;\r\n    background-repeat: no-repeat;\r\n}\r\n#patient-eligibility .help {\r\n    color: #83156f;\r\n}\r\n#patient-eligibility .circle p {\r\n    font-size: 1.25em;\r\n    padding-bottom: 50px;\r\n    padding-left: 0;\r\n    padding-top: 5px;\r\n    line-height: 30px;\r\n}\r\n#patient-eligibility .circle-div p {\r\n    line-height: 25px;\r\n    padding-top: 5px;\r\n}\r\n#patient-eligibility .title-box2-drug {\r\n    background-image: url(../images/box1-blue.png);\r\n}\r\n#patient-eligibility .title-box2-inf {\r\n    background-image: url(../images/box1-yellow.png);\r\n}\r\n#patient-eligibility .help p {\r\n    display: block;\r\n    margin-bottom: 0;\r\n}\r\n#patient-eligibility .circle {\r\n    padding-left: 50px;\r\n}\r\n#patient-eligibility .circle-div {\r\n    padding-bottom: 63px;\r\n}\r\n\r\n.content-buttons .col-lg-4 {\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n}\r\n.mobile {\r\n    display: none;\r\n}\r\n#home-container button {\r\n    padding: 10px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    margin-top: 3px;\r\n}\r\n.title-home {\r\n    width: 100%;\r\n    float: left;\r\n    color: #fff;\r\n    text-align: center;\r\n    font-size: 27px;\r\n    line-height: 35px;\r\n    height: 82px;\r\n    background-color: #83156f;\r\n    padding-bottom: 0;\r\n    padding-top: 25px;\r\n    border-radius: 30px 30px 0 0;\r\n    text-align: center;\r\n}\r\n.vabysmo-img {\r\n}\r\n.ui-tabs .ui-tabs-nav li {\r\n    margin: 0 !important;\r\n}\r\n.ui-state-default a,\r\n.ui-state-default a:link,\r\n.ui-state-default a:visited {\r\n}\r\n#home-container-patients img {\r\n    max-width: 100%;\r\n}\r\n.hcp #home-container-patients a {\r\n    text-decoration: underline;\r\n    color: #00f;\r\n}\r\n\r\n.after-title {\r\n    width: 100%;\r\n    float: left;\r\n    background-color: #f2f2f2;\r\n    padding: 30px;\r\n    color: #83156f;\r\n    padding-left: 50px;\r\n    padding-right: 50px;\r\n}\r\n.cost1 {\r\n    padding-left: 40px;\r\n}\r\n.after-title p {\r\n    font-size: 22px;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    padding-bottom: 20px;\r\n}\r\n.center-cols {\r\n    width: 100%;\r\n    float: left;\r\n    background-color: #f2f2f2;\r\n}\r\n.center-col_1 {\r\n    width: 33.3%;\r\n    float: left;\r\n    text-align: center;\r\n    padding: 30px;\r\n    border-right: 1px solid #83156f;\r\n}\r\n.center-col_2 {\r\n    width: 33.3%;\r\n    float: left;\r\n    text-align: center;\r\n    padding: 30px;\r\n    border-right: 1px solid #83156f;\r\n}\r\n.center-col_3 {\r\n    width: 33.3%;\r\n    float: left;\r\n    text-align: center;\r\n    padding: 30px;\r\n}\r\n.center-cols img {\r\n    margin-bottom: 20px;\r\n}\r\n.five-cost {\r\n    width: 50%;\r\n    float: left;\r\n    color: #83156f;\r\n    font-size: 15px;\r\n}\r\n.five-cost strong {\r\n    font-size: 15px;\r\n}\r\n.five-cost span {\r\n    padding-right: 40px;\r\n    display: block;\r\n}\r\n.five-cost img {\r\n    float: left;\r\n    margin-right: 15px;\r\n    margin-bottom: 30px;\r\n}\r\n.patients .ui-datepicker table {\r\n    overflow-x: auto !important;\r\n    font-size: 13px !important;\r\n    display: table;\r\n}\r\n.site-text-toggle {\r\n    display: inline-block;\r\n    border: 1px solid #83156f;\r\n    height: 25px;\r\n    width: 25px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n    padding-top: 0;\r\n}\r\na.size {\r\n    color: #83156f !important;\r\n    font-weight: bold;\r\n}\r\n#enlarger-size-small,\r\n#enlarger-size-medium,\r\n#enlarger-size-large {\r\n    text-decoration: none;\r\n}\r\n.left_text {\r\n    width: 40%;\r\n    float: left;\r\n}\r\n.right_text {\r\n    width: 50%;\r\n    float: left;\r\n    padding: 20px;\r\n    box-shadow: 0 0 7px;\r\n    margin-bottom: 40px;\r\n}\r\nul.submenuitems {\r\n    display: none;\r\n    position: absolute;\r\n    left: 0;\r\n    z-index: 2;\r\n    border-top: 0;\r\n    min-width: 99%;\r\n}\r\nul.submenuitems li {\r\n    width: 100% !important;\r\n    text-align: left;\r\n    border-radius: 0px;\r\n    border-top: 1px solid #fff;\r\n}\r\nul.submenuitems li a {\r\n    width: 100%;\r\n    padding: 7px 15px;\r\n    text-align: center;\r\n}\r\n#header-patients li {\r\n}\r\n.arrow {\r\n    border: solid #4d4d4f;\r\n    border-width: 0 1px 1px 0;\r\n    display: inline-block;\r\n    padding: 3px;\r\n    margin-left: 5px;\r\n    margin-bottom: 3px;\r\n}\r\n.down {\r\n    transform: rotate(45deg);\r\n    -webkit-transform: rotate(45deg);\r\n}\r\n.nav .icon-mm {\r\n    float: right;\r\n    margin-right: 140px;\r\n    width: 55px;\r\n}\r\n.line-user {\r\n    width: 100%;\r\n}\r\n.mm {\r\n    padding-top: 10px;\r\n    padding-bottom: 20px;\r\n}\r\n.round-mm {\r\n    width: 40px;\r\n    height: 35px;\r\n    border-radius: 50px;\r\n    text-align: center;\r\n    padding: 5px;\r\n    border: 1px solid #4d4d4f;\r\n    margin: 10px;\r\n    margin-bottom: 20px;\r\n    margin-top: 0;\r\n    float: left;\r\n    font-weight: bold;\r\n}\r\n#header-patients li ul li {\r\n    width: 100%;\r\n}\r\n#header-patients li.has-child {\r\n}\r\n.submenuitems li a {\r\n    border: 0 !important;\r\n    margin: 0;\r\n}\r\nli.has-child a:hover .arrow {\r\n    border: solid #fff;\r\n    border-width: 0 1px 1px 0;\r\n}\r\nli.has-child:hover ul.submenuitems {\r\n    display: block;\r\n}\r\n.clear {\r\n    width: 100%;\r\n    display: block;\r\n}\r\n.right_text .underline {\r\n    display: block;\r\n    margin-bottom: 7px;\r\n    text-decoration: underline;\r\n}\r\n.tooltip {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\na.ot-sdk-show-settings {\r\n    color: #fff !important;\r\n    cursor: pointer;\r\n}\r\n/* Tooltip text */\r\n.tooltip .tooltiptext {\r\n    visibility: hidden;\r\n    width: 230px;\r\n    background-color: #83156f;\r\n    color: #fff;\r\n    text-align: center;\r\n    padding: 15px;\r\n    border-radius: 6px;\r\n    position: absolute;\r\n    z-index: 1;\r\n    font-size: 12px;\r\n    left: -240px;\r\n    top: -50px;\r\n}\r\nimg.excel {\r\n    margin-bottom: 10px;\r\n    width: 30px;\r\n}\r\n.hp-footer-bar {\r\n    background-color: #83156f;\r\n    height: 15px;\r\n    border-radius: 0 0 30px 30px;\r\n    margin-bottom: 30px;\r\n    width: 100%;\r\n    float: left;\r\n}\r\n.tooltip a {\r\n    text-decoration: none !important;\r\n}\r\n/* Show the tooltip text when you mouse over the tooltip container */\r\n.tooltip:hover .tooltiptext {\r\n    visibility: visible;\r\n}\r\n.mat-card {\r\n    transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);\r\n    display: block;\r\n    position: relative;\r\n    padding: 16px;\r\n    border-radius: 4px;\r\n    background: #eee;\r\n}\r\n.small-login p {\r\n    margin-bottom: 20px;\r\n}\r\n.find_patient p {\r\n    margin-bottom: 20px;\r\n}\r\n#hcp_post_content {\r\n    width: 100%;\r\n    display: block;\r\n    float: left;\r\n}\r\n.leftSpace input[type=\"text\"] {\r\n    width: 100%;\r\n    max-width: 150px;\r\n}\r\n#hcp_post_content .find_patient p {\r\n    width: 100% !important;\r\n    float: left !important;\r\n}\r\n.status-icon.active {\r\n    border-radius: 20px;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n    background-color: #24ae3d;\r\n    color: #fff;\r\n    display: inline-block;\r\n    margin-top: 2px;\r\n    min-width: 30px;\r\n    text-align: center;\r\n    font-size: 13px;\r\n    margin-left: 7px;\r\n    line-height: 15px;\r\n    padding: 5px;\r\n}\r\n.status-icon.inactive {\r\n    border-radius: 20px;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n    background-color: #ffcc33;\r\n    color: #000;\r\n    display: inline-block;\r\n    min-width: 30px;\r\n    text-align: center;\r\n    font-size: 13px;\r\n    margin-left: 7px;\r\n    line-height: 15px;\r\n    padding: 5px;\r\n}\r\n.status-icon.rejected {\r\n    border-radius: 20px;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n    background-color: #e1304c;\r\n    color: #fff;\r\n    display: inline-block;\r\n    margin-top: 2px;\r\n    min-width: 30px;\r\n    text-align: center;\r\n    font-size: 13px;\r\n    cursor: pointer;\r\n    margin-left: 7px;\r\n    line-height: 15px;\r\n    padding: 5px;\r\n}\r\nbutton[type=\"reset\"] {\r\n    background-color: #fff;\r\n    border: 2px solid #d8d8d8 !important;\r\n    color: #4d4d4f !important;\r\n}\r\n.patientProfile table {\r\n    margin-top: 0px;\r\n}\r\n.color {\r\n    color: #83156f;\r\n    font-weight: normal;\r\n    margin-top: 0;\r\n}\r\n.profile-box label {\r\n    width: 100%;\r\n    text-align: left;\r\n    margin-bottom: 4px;\r\n}\r\n.profile-box input[type=\"text\"] {\r\n    width: 95%;\r\n    margin: 0;\r\n    padding: 7px;\r\n    border-radius: 4px;\r\n}\r\n.profile-box .select_container {\r\n    width: 95%;\r\n    margin: 0;\r\n    padding: 7px;\r\n    border-radius: 4px;\r\n}\r\n.profile-box select {\r\n    border: 0;\r\n    max-width: 100%;\r\n    width: 100%;\r\n}\r\n.find_patient input[type=\"text\"] {\r\n    max-width: 100%;\r\n    width: 22%;\r\n    padding: 7px;\r\n    float: left;\r\n    margin-right: 20px;\r\n}\r\n.find_patient input[type=\"password\"] {\r\n    max-width: 100%;\r\n    width: 95%;\r\n    padding: 7px;\r\n    float: left;\r\n    margin-right: 20px;\r\n}\r\n.form-validate-create-password input[type=\"text\"] {\r\n    max-width: 100%;\r\n    width: 95%;\r\n    padding: 12px;\r\n    float: left;\r\n    margin-right: 20px;\r\n}\r\n.form-validate-password label {\r\n    text-align: left;\r\n    width: 100%;\r\n    padding-bottom: 7px;\r\n}\r\n.form-validate-password .prompt-error {\r\n    font-size: 12px;\r\n}\r\n\r\n.form-validate-create-password label {\r\n    text-align: left;\r\n    width: 100%;\r\n    padding-bottom: 7px;\r\n}\r\n.form-validate-create-password .prompt-error {\r\n    font-size: 12px;\r\n    width: 100%;\r\n}\r\n.thank-you h3 {\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    color: #83156f;\r\n}\r\n.thank-you span {\r\n    color: #83156f;\r\n}\r\n.thank-you .col-sm-12 {\r\n    margin-bottom: 15px;\r\n}\r\n.patients .thank-you table {\r\n    width: 50%;\r\n    border-spacing: 0px;\r\n}\r\n.patients .thank-you th {\r\n    background: none;\r\n    color: #83156f;\r\n    border-bottom: 1px solid #83156f;\r\n}\r\n.patients .thank-you td {\r\n    background: none;\r\n    border-bottom: 1px solid #4d4d4f;\r\n}\r\n.find_patient .select_container {\r\n    max-width: 100%;\r\n    width: 22%;\r\n    padding: 7px;\r\n    float: left;\r\n    margin-right: 20px;\r\n}\r\nlabel.ssn {\r\n    margin-bottom: 20px !important;\r\n}\r\nb {\r\n    font-weight: 900;\r\n}\r\n.pi_tab1 {\r\n    width: 60% !important;\r\n}\r\n.pi_tab1.second_row {\r\n    width: 40% !important;\r\n}\r\n.user-area {\r\n    padding: 0 0 8px;\r\n    margin: 0;\r\n    list-style: none;\r\n    line-height: 1.44em;\r\n    float: right;\r\n    margin-top: 20px;\r\n}\r\n.user-area li {\r\n    float: left;\r\n    list-style: none;\r\n}\r\n.user-area .size {\r\n    padding: 0 40px 0 0;\r\n    /*background: url(../images/sprite-1.png) no-repeat 100% 0;*/\r\n}\r\n.user-area a {\r\n    float: left;\r\n    text-decoration: none;\r\n    color: #83156f !important;\r\n}\r\n/*\r\n  * Remove text-shadow in selection highlight: h5bp.com/i\r\n  * These selection declarations have to be separate.\r\n  * Customize the background color to match your design.\r\n  */\r\ninput#fileupload,\r\ninput#fileupload2 {\r\n    height: 60px;\r\n    width: 250px;\r\n}\r\n.isi strong {\r\n    color: #83156f;\r\n}\r\n\r\n.isi h2 {\r\n    font-size: 16px !important;\r\n}\r\n#progress {\r\n    float: left;\r\n}\r\n#progress2 {\r\n    float: left;\r\n}\r\n.top {\r\n    width: 100%;\r\n    background-color: #f5f5f5;\r\n}\r\n.top-header {\r\n    width: 40%;\r\n    float: right;\r\n}\r\n.top a {\r\n    color: #fff !important;\r\n    background-color: #83156f;\r\n    background-image: none;\r\n    padding: 10px;\r\n    display: block;\r\n    float: left;\r\n    text-decoration: none;\r\n    font-size: 15px;\r\n}\r\n.top-header nav a {\r\n    color: #83156f;\r\n    background-image: none;\r\n    display: block;\r\n    float: right;\r\n    text-decoration: none;\r\n    margin-top: 5px;\r\n    margin-right: 0px;\r\n    font-weight: bold;\r\n    margin-bottom: 5px;\r\n    background-image: url(../images/change-link.png);\r\n    background-repeat: no-repeat;\r\n    background-position: right;\r\n    padding-right: 30px;\r\n}\r\n.hcp .top-header nav a.active {\r\n    color: #4d4d4f !important;\r\n    background-color: #fff;\r\n    padding: 10px;\r\n    display: block;\r\n    float: left;\r\n    text-decoration: none;\r\n    font-size: 15px;\r\n    background-image: none;\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n}\r\n.patients .top a.active {\r\n    color: #4d4d4f !important;\r\n    padding: 10px;\r\n    display: block;\r\n    float: left;\r\n    text-decoration: none;\r\n    font-size: 15px;\r\n    background-image: none;\r\n    background-color: #fff;\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n}\r\nh2 a {\r\n    color: #83156f;\r\n}\r\n.hcp-solutions {\r\n    float: right !important;\r\n    background-color: #83156f !important;\r\n    color: #fff;\r\n    background-image: none !important;\r\n    padding-left: 40px !important;\r\n    padding-right: 40px !important;\r\n    border-radius: 3px;\r\n}\r\nnav.hcp {\r\n    width: 100%;\r\n}\r\n.hcp button {\r\n    background-color: #fff;\r\n    color: #83156f !important;\r\n    border: 2px solid #83156f;\r\n    border-radius: 7px;\r\n    color: #fff;\r\n    padding: 7px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    text-decoration: none;\r\n    margin-right: 20px;\r\n}\r\n.patients button {\r\n    background-color: #fff;\r\n    color: #83156f !important;\r\n    border: 2px solid #83156f;\r\n    border-radius: 7px;\r\n    color: #fff;\r\n    padding: 8px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    text-decoration: none;\r\n    margin-right: 20px;\r\n}\r\n.loading {\r\n    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);\r\n    bottom: 0;\r\n    display: none;\r\n    left: 0;\r\n    padding: 5%;\r\n    position: fixed;\r\n    right: 0;\r\n    top: 0;\r\n    z-index: 9999;\r\n}\r\n.loading .popup-box {\r\n    margin: 0 auto;\r\n    width: 300px;\r\n    overflow: auto;\r\n    padding-bottom: 20px;\r\n    text-align: center;\r\n}\r\nbutton:disabled {\r\n    background-image: none;\r\n}\r\n.hcp button.submit-hcp {\r\n    background-color: #83156f;\r\n}\r\n.ui-state-highlight,\r\n.ui-widget-content .ui-state-highlight,\r\n.ui-widget-header .ui-state-highlight {\r\n    border: 1px solid #83156f !important;\r\n}\r\n.patients button.submit-patients {\r\n    background-color: #83156f;\r\n    color: #fff !important;\r\n}\r\n.eligibility .box-drug ul {\r\n}\r\n.title-box2-drug {\r\n}\r\n.radio {\r\n    display: block;\r\n    position: relative;\r\n    padding-left: 25px;\r\n    margin-bottom: 5px;\r\n    cursor: pointer;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n.radios .radio {\r\n    padding-top: 0;\r\n}\r\n.radio input {\r\n    position: absolute;\r\n    opacity: 0;\r\n}\r\n.checkmark {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 20px;\r\n    width: 20px;\r\n    background-color: #fff;\r\n    border: 1px solid #4d4d4f;\r\n    border-radius: 50%;\r\n}\r\nlabel.radio {\r\n    text-align: left;\r\n    width: auto;\r\n}\r\n/* On mouse-over, add a grey background color */\r\n.radio:hover input ~ .checkmark {\r\n    background-color: #fff;\r\n}\r\n\r\n/* When the radio button is checked, add a blue background */\r\n.radio input:checked ~ .checkmark {\r\n    background-color: #fff;\r\n    border: 1px solid #83156f;\r\n}\r\n\r\n/* Create the indicator (the dot/circle - hidden when not checked) */\r\n.checkmark:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    display: none;\r\n}\r\n\r\n/* Show the indicator (dot/circle) when checked */\r\n.radio input:checked ~ .checkmark:after {\r\n    display: block;\r\n}\r\n.using-the-program {\r\n}\r\n.using-the-program table {\r\n    border-collapse: separate;\r\n    border-spacing: 0px;\r\n    width: 100%;\r\n    font-size: inherit;\r\n    margin-bottom: 20px;\r\n}\r\n.using-the-program h1 {\r\n    font-size: 1.5em;\r\n}\r\n.using-the-program table td.first {\r\n    width: 10px;\r\n}\r\n.using-the-program ul {\r\n    color: #83156f;\r\n    font-size: inherit;\r\n    margin-top: 10px;\r\n    margin-left: 20px;\r\n}\r\n.using-the-program table td {\r\n    background-color: transparent;\r\n    border: 0;\r\n    vertical-align: top;\r\n    padding: 2px !important;\r\n    color: #83156f;\r\n    line-height: 20px;\r\n    font-weight: 600;\r\n}\r\n.using-the-program img {\r\n    margin-left: -30px;\r\n    margin-top: -28px;\r\n    margin-bottom: -8px;\r\n    width: 100px;\r\n}\r\n.using-the-program2 {\r\n    background-image: url(../images/2_circle.png);\r\n    background-repeat: no-repeat;\r\n    background-position: top -6px right -10px;\r\n    background-size: 100px auto;\r\n    padding: 20px;\r\n}\r\n.using-the-program3 {\r\n    background-image: url(../images/3_circle.png);\r\n    background-repeat: no-repeat;\r\n    background-position: top -6px left -10px;\r\n    background-size: 100px auto;\r\n    padding: 20px 20px 3px 20px;\r\n}\r\n.using-the-program4 {\r\n    background-image: url(../images/4_circle.png);\r\n    background-repeat: no-repeat;\r\n    background-position: top -6px right -10px;\r\n    background-size: 100px auto;\r\n    padding: 20px;\r\n}\r\n.using-the-program.arrow-bottom:after {\r\n    content: \" \";\r\n    position: absolute;\r\n    border-top: 25px solid #83156f;\r\n    border-right: 25px solid transparent;\r\n    border-left: 25px solid transparent;\r\n    border-bottom: none;\r\n    margin-top: 0px;\r\n    margin-left: 28%;\r\n}\r\n.using-the-program1.arrow-bottom:after {\r\n    margin-top: 0px;\r\n}\r\n.using-the-program3.arrow-bottom:after {\r\n    margin-left: 26%;\r\n    margin-top: 2px;\r\n}\r\n.using-the-program2.arrow-bottom:after {\r\n    margin-left: 26%;\r\n    margin-top: 20px;\r\n}\r\n.using-the-program4.arrow-bottom:after {\r\n    margin-top: -21px;\r\n}\r\nh1 {\r\n    margin-top: 30px;\r\n}\r\nh1 {\r\n    font-size: 20px;\r\n    color: #83156f;\r\n    font-weight: normal;\r\n    font-size: 1.5em;\r\n}\r\nh2 {\r\n    font-size: 20px;\r\n    color: #83156f;\r\n    font-weight: normal;\r\n    font-size: 1.5em;\r\n}\r\n\r\n.radio .checkmark:after {\r\n    top: 5px;\r\n    left: 5px;\r\n    width: 50%;\r\n    height: 50%;\r\n    border-radius: 50%;\r\n    background: #83156f;\r\n}\r\n.col1 {\r\n    width: 50%;\r\n    float: left;\r\n}\r\n.col2 {\r\n    width: 50%;\r\n    float: left;\r\n}\r\n.enroll_but {\r\n    background-color: #fff;\r\n    padding: 20px;\r\n    font-size: 18px;\r\n    display: block;\r\n    float: left;\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n    margin-left: 30px;\r\n    margin-top: 20px;\r\n    color: #83156f !important;\r\n    border: 2px solid #83156f;\r\n    font-weight: bold;\r\n    border-radius: 10px;\r\n}\r\n.col2 .enroll_but {\r\n    float: right;\r\n    margin-right: 20px;\r\n}\r\n.patients .eligibility td {\r\n    background-color: #f2f2f2;\r\n}\r\n.patients .eligibility table {\r\n    border-collapse: separate;\r\n    border-spacing: 0;\r\n}\r\n.register-block {\r\n    float: left;\r\n    margin: 20px 10px;\r\n    width: 100%;\r\n}\r\n.register-block a img {\r\n    float: left;\r\n    margin-right: 20px;\r\n}\r\n#tabs {\r\n    float: left;\r\n    border: 0;\r\n}\r\n.ui-tabs .ui-tabs-nav {\r\n    border: 0;\r\n}\r\n.ui-tabs .ui-tabs-nav li {\r\n    border: 0;\r\n}\r\n#hcp_post_content form p {\r\n    float: none;\r\n    width: auto;\r\n}\r\n.hcp th {\r\n    text-align: left;\r\n}\r\n.hcp td,\r\nth {\r\n    padding: 6px;\r\n}\r\n.hcp table {\r\n    border-collapse: separate;\r\n    border-spacing: 0px;\r\n    width: 100%;\r\n}\r\n.hcp th {\r\n    text-align: left;\r\n}\r\n.ui-widget-header {\r\n    background: #fff !important;\r\n}\r\n.ui-state-default,\r\n.ui-widget-content .ui-state-default,\r\n.ui-widget-header .ui-state-default {\r\n    background: #fff !important;\r\n}\r\n.check {\r\n    float: left;\r\n}\r\n.patients th {\r\n    text-align: left;\r\n    font-weight: normal;\r\n}\r\n.patients td,\r\nth {\r\n    padding: 6px;\r\n}\r\n.patients td.like-th {\r\n    background-color: transparent;\r\n    background-image: url(../images/isi-gr.png);\r\n    background-repeat: repeat-x;\r\n    color: #fff;\r\n    text-align: left;\r\n    font-weight: bold;\r\n}\r\n.patients td.like-td {\r\n    background-color: #f2f2f2;\r\n    color: #4d4d4f;\r\n}\r\n.patients th.like-td {\r\n    background-color: #f2f2f2;\r\n    color: #4d4d4f;\r\n    background-image: none;\r\n}\r\n#tabs .ui-state-active a {\r\n    outline: 0 !important;\r\n}\r\n.patients table {\r\n    border-collapse: separate;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    margin: 0;\r\n}\r\n.border-color {\r\n    border: 2px solid #83156f;\r\n    padding: 10px;\r\n    display: block;\r\n    float: left;\r\n    margin-bottom: 20px;\r\n}\r\n#tabs-1 .border-color {\r\n    border: 0;\r\n    padding: 0;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n}\r\n#tabs-3 .border-color {\r\n    border: 0;\r\n    padding: 0;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n}\r\ntable {\r\n}\r\ntable.eligibility {\r\n    border-collapse: separate;\r\n    border-spacing: 0;\r\n    margin-top: 20px;\r\n    padding: 15px;\r\n    background-color: #f2f2f2;\r\n    width: 97%;\r\n}\r\ntable.eligibility td {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n.right-top {\r\n    float: left;\r\n    margin-top: 20px;\r\n    color: #000;\r\n    padding-right: 20px;\r\n}\r\n.right-top a {\r\n    color: #000 !important;\r\n    font-weight: bold;\r\n    line-height: 25px;\r\n}\r\n.border-right {\r\n    border-right: 2px solid #000;\r\n    margin-right: 20px;\r\n    margin-bottom: 10px;\r\n}\r\n.right-top a {\r\n    color: #83156f;\r\n    text-decoration: none;\r\n}\r\n#header-hcp #nav li a:hover {\r\n    background-color: #83156f;\r\n    text-decoration: none;\r\n    border: 1px solid #fff !important;\r\n    color: #fff;\r\n}\r\n.hcp #navsubmenu li a:hover {\r\n    background-color: #83156f;\r\n    text-decoration: none;\r\n    border: 1px solid #fff !important;\r\n    color: #fff;\r\n}\r\n#tabs .ui-state-active a {\r\n    background-color: #fff;\r\n    text-decoration: none;\r\n    border-bottom: 2px solid #83156f !important;\r\n}\r\n.hcp #tabs li a:hover {\r\n    background-color: #fff;\r\n    text-decoration: none;\r\n    border-bottom: 2px solid #83156f !important;\r\n}\r\n.ui-tabs .ui-tabs-nav {\r\n    height: auto;\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n.ui-tabs .ui-tabs-nav .ui-tabs-anchor {\r\n    background: #fff;\r\n    padding-left: 40px !important;\r\n    padding-right: 40px !important;\r\n    border: 0 !important;\r\n    font-family: \"AvenirNextLTW01-Regular\" !important;\r\n    font-size: 16px;\r\n}\r\n#home-container h1 {\r\n    font-size: 25px;\r\n}\r\n#home-container-patients {\r\n    width: 100%;\r\n    display: block;\r\n    float: left;\r\n    margin-bottom: 40px;\r\n    margin-top: 40px;\r\n}\r\n\r\n#home-container-hcp {\r\n    width: 100%;\r\n    display: block;\r\n    float: left;\r\n    margin-bottom: 40px;\r\n}\r\n#home-container-hcp img {\r\n    border: 2px solid #83156f;\r\n    width: 100%;\r\n}\r\n#header-patients #nav li a:hover {\r\n    background-color: #83156f;\r\n    text-decoration: none;\r\n    border: 1px solid #fff !important;\r\n    color: #fff;\r\n}\r\n#nav:hover li.selected a {\r\n    border-radius: 5px;\r\n}\r\nul.submenuitems li a:hover {\r\n    border-radius: 0px;\r\n}\r\n\r\n.eligibility .col-lg-4 {\r\n    margin-right: 10px;\r\n    width: 32.6%;\r\n}\r\n\r\n.eligibility ul {\r\n    margin-bottom: 0;\r\n}\r\n.eligibility ul ul {\r\n    margin-top: 7px;\r\n}\r\n.eligibility .box-drug ul {\r\n    margin-bottom: 0;\r\n}\r\n.box-drug strong {\r\n    color: #83156f;\r\n}\r\n\r\n.patients .box-drug strong {\r\n    color: #83156f;\r\n}\r\n.hcp ul li span {\r\n    color: #4d4d4f;\r\n}\r\nspan .bluetext {\r\n    color: #83156f;\r\n}\r\n.patients ul li span {\r\n    color: #4d4d4f;\r\n}\r\n\r\n.title-box {\r\n    width: 100%;\r\n    display: block;\r\n    background-color: #6163ae;\r\n    color: #fff;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    text-align: center;\r\n    float: left;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n}\r\n.hcp .title-box {\r\n    width: 100%;\r\n    display: block;\r\n    background-color: #83156f;\r\n    color: #fff;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    text-align: center;\r\n    float: left;\r\n}\r\n.content-box {\r\n    background-color: #f6f5fb;\r\n    display: block;\r\n    float: left;\r\n    margin-top: 10px;\r\n    min-height: 80px;\r\n    padding: 10px 20px;\r\n    width: 100%;\r\n}\r\n.eligibility .col-lg-6 {\r\n    margin-right: 10px;\r\n    width: 49.4%;\r\n}\r\n.using1 {\r\n    background-image: url(../images/using1.png);\r\n    background-repeat: no-repeat;\r\n    color: #fff;\r\n    height: 150px;\r\n    margin-top: 30px;\r\n    padding-left: 50px;\r\n    padding-right: 20px;\r\n    padding-top: 30px;\r\n    text-align: left;\r\n    width: 662px;\r\n}\r\n\r\n.using2 {\r\n    background-image: url(../images/using2.png);\r\n    background-repeat: no-repeat;\r\n    color: #fff;\r\n    height: 450px;\r\n    margin-top: 10px;\r\n    padding-left: 50px;\r\n    padding-top: 30px;\r\n    text-align: left;\r\n    width: 662px;\r\n    padding-right: 120px;\r\n}\r\n\r\n.using3 {\r\n    background-image: url(../images/using3.png);\r\n    background-repeat: no-repeat;\r\n    color: #fff;\r\n    height: 200px;\r\n    margin-top: 10px;\r\n    padding-left: 50px;\r\n    padding-right: 20px;\r\n    padding-top: 20px;\r\n    text-align: left;\r\n    width: 662px;\r\n}\r\n\r\n.using4 {\r\n    background-image: url(../images/using4.png);\r\n    background-repeat: no-repeat;\r\n    color: #fff;\r\n    height: 300px;\r\n    margin-top: 10px;\r\n    padding-left: 50px;\r\n    padding-right: 110px;\r\n    padding-top: 35px;\r\n    text-align: left;\r\n    width: 662px;\r\n}\r\n.using4 img {\r\n    display: none;\r\n}\r\n.using4 ul {\r\n    margin-left: 0px;\r\n    color: #fff;\r\n    font-size: 15px;\r\n    margin-top: 20px;\r\n}\r\n.padding {\r\n    display: block;\r\n    float: left;\r\n    margin-left: 160px;\r\n}\r\n\r\n.using5 {\r\n    background-image: url(../images/using5.png);\r\n    background-repeat: no-repeat;\r\n    color: #fff;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n    height: 195px;\r\n    margin-top: 10px;\r\n    padding-left: 50px;\r\n    padding-right: 70px;\r\n    padding-top: 20px;\r\n    text-align: left;\r\n    width: 662px;\r\n}\r\n\r\n.using1-hcp {\r\n    background-image: url(../images/using-hcp1.png);\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    height: 130px;\r\n    margin-top: 10px;\r\n    padding-left: 110px;\r\n    padding-right: 100px;\r\n    padding-top: 30px;\r\n    text-align: left;\r\n    width: 662px;\r\n    color: #fff;\r\n}\r\n.using2-hcp {\r\n    background-image: url(../images/using-hcp2.png);\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    height: 400px;\r\n    margin-top: 10px;\r\n    padding-left: 110px;\r\n    padding-right: 120px;\r\n    padding-top: 20px;\r\n    text-align: left;\r\n    width: 662px;\r\n    color: #fff;\r\n}\r\n.using2-hcp a {\r\n    color: #fff !important;\r\n}\r\n.using3-hcp {\r\n    background-image: url(../images/using3-hcp.png);\r\n    background-repeat: no-repeat;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    height: 160px;\r\n    margin-top: 10px;\r\n    padding-left: 50px;\r\n    padding-right: 20px;\r\n    padding-top: 30px;\r\n    text-align: left;\r\n    width: 662px;\r\n}\r\n\r\n.using4-hcp {\r\n    background-image: url(../images/using-hcp4.png);\r\n    background-repeat: no-repeat;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    height: 170px;\r\n    margin-top: 10px;\r\n    padding-left: 20px;\r\n    padding-right: 110px;\r\n    padding-top: 20px;\r\n    text-align: left;\r\n    width: 662px;\r\n}\r\nlabel.ssn {\r\n    margin-bottom: 20px !important;\r\n}\r\n.messages-popupx {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.messages-popupx .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    box-shadow: 0 0 5px 5px #555;\r\n    margin: 0 auto;\r\n    width: 800px;\r\n    padding: 20px;\r\n    position: relative;\r\n}\r\n.orange {\r\n    color: #83156f;\r\n    font-weight: bold;\r\n}\r\n.content-box2 {\r\n    display: block;\r\n    float: left;\r\n    min-height: 160px;\r\n    margin-top: 10px;\r\n    width: 100%;\r\n    margin-bottom: 30px;\r\n}\r\n.help .col-md-2 {\r\n    background-image: url(../images/circle.png);\r\n    background-repeat: no-repeat;\r\n    color: #fff;\r\n    font-size: 40px;\r\n    font-weight: bold;\r\n    height: 121px;\r\n    padding-left: 35px;\r\n    text-align: left;\r\n    margin-top: 10px;\r\n}\r\n\r\n.help .col-md-3 {\r\n    color: #83156f;\r\n    font-size: 22px;\r\n    padding-top: 20px;\r\n    font-weight: normal;\r\n}\r\n.help .col-md-7 {\r\n    color: #83156f;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    padding-right: 55px;\r\n    padding-top: 20px;\r\n}\r\n.patients .help .col-md-7 {\r\n    color: #83156f;\r\n    font-size: 19px;\r\n    font-weight: normal;\r\n    padding-right: 15px;\r\n    padding-top: 20px;\r\n    margin-left: 20px;\r\n}\r\n\r\n.patients .help .col-md-3 span {\r\n    font-size: 22px;\r\n    font-weight: normal;\r\n}\r\n.patients .help .col-md-3 span.small-p {\r\n    font-size: 16px;\r\n    font-weight: normal;\r\n}\r\n.help .col-md-3 strong {\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n#provider-eligibility h2 {\r\n    font-size: 1.25em;\r\n    color: #00759f;\r\n}\r\n.using-hcp-box table td.first {\r\n    width: 40px;\r\n}\r\n.using-hcp-box img {\r\n    margin-left: -30px;\r\n    margin-top: -28px;\r\n    width: 100px;\r\n}\r\n\r\n.agree_form label {\r\n    text-align: left;\r\n    width: 100%;\r\n}\r\nh2.blue {\r\n    color: #00759f;\r\n}\r\n#provider-eligibility h3 {\r\n    font-size: 1em;\r\n    color: #00759f;\r\n    font-weight: normal;\r\n}\r\n.eligibility .help ul {\r\n    color: #83156f;\r\n}\r\n.eligibility .help ul li span {\r\n    color: #83156f;\r\n}\r\n.help .col-md-2 span.d1 {\r\n    float: left;\r\n    font-size: 18px;\r\n    padding-top: 35px;\r\n}\r\n.help .col-md-2 span.d2 {\r\n    float: left;\r\n    font-size: 35px;\r\n    padding-top: 30px;\r\n}\r\n.find_pass input[type=\"text\"] {\r\n    max-width: 100%;\r\n    width: 100%;\r\n    float: left;\r\n    /* margin-right: 20px; */\r\n}\r\n.hcp .nav li,\r\n.hcp .submenu .nav li {\r\n    width: 185px;\r\n}\r\n#provider-eligibility .circle1 {\r\n    background-image: url(../images/circle1.png);\r\n    background-repeat: no-repeat;\r\n    background-size: 105px 105px;\r\n    padding-left: 125px;\r\n    min-height: 105px;\r\n    padding-right: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n#provider-eligibility .circle2 {\r\n    background-image: url(../images/circle2.png);\r\n    background-repeat: no-repeat;\r\n    background-size: 105px 105px;\r\n    padding-left: 125px;\r\n    min-height: 105px;\r\n    padding-right: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n#provider-eligibility p {\r\n    margin-bottom: 20px;\r\n}\r\n#provider-eligibility .help ul {\r\n    display: block;\r\n    padding-left: 20px;\r\n}\r\n.using-hcp-box {\r\n    background-color: #f4f4fa;\r\n    color: #83156f;\r\n    padding: 20px 10px 8px 0;\r\n    border-radius: 30px;\r\n    font-size: inherit;\r\n    display: block;\r\n    clear: both;\r\n    margin-bottom: 50px;\r\n    margin-top: 30px;\r\n    width: 560px;\r\n    font-weight: bold;\r\n    padding-left: 0;\r\n    margin-left: 10px;\r\n}\r\n.border {\r\n    border: 1px solid #dee2e6 !important;\r\n}\r\n.using-hcp .title {\r\n    color: #00759f;\r\n    background-color: transparent;\r\n    width: auto;\r\n    font-family: \"Avenir Next LT W01 Bold\";\r\n}\r\n.using-hcp span {\r\n    color: #83156f !important;\r\n}\r\n.using-hcp ul {\r\n    padding-left: 1rem;\r\n    line-height: 1.3;\r\n}\r\n.using-hcp ul li ul li {\r\n    list-style: circle !important;\r\n}\r\n.using-hcp ul li ul li:before {\r\n    display: none;\r\n}\r\n.using-hcp-box table {\r\n    border-collapse: separate;\r\n    border-spacing: 0px;\r\n    width: 100%;\r\n    font-size: inherit;\r\n    margin-bottom: 20px;\r\n}\r\n.using-hcp-box table td {\r\n    background-color: transparent;\r\n    border: 0;\r\n    vertical-align: top;\r\n    padding: 2px !important;\r\n    color: #4d4d4f;\r\n    font-weight: bold;\r\n}\r\n.using-the-program .using-hcp-box table td {\r\n    background-color: transparent;\r\n    border: 0;\r\n    vertical-align: top;\r\n    padding: 2px !important;\r\n    color: #83156f;\r\n    font-weight: bold;\r\n}\r\n.using-hcp-box table {\r\n    margin: 0;\r\n}\r\n.using-hcp-box2 {\r\n    background-image: url(../images/2_circle.png);\r\n    background-repeat: no-repeat;\r\n    background-position: top -7px right -11px;\r\n    background-size: 110px auto;\r\n    padding: 20px;\r\n}\r\n.using-hcp-box4 {\r\n    background-image: url(../images/4_circle.png);\r\n    background-repeat: no-repeat;\r\n    background-position: top -9px right -11px;\r\n    background-size: 118px auto;\r\n    padding: 10px 10px 0 10px;\r\n    min-height: 100px;\r\n}\r\n.using-hcp-box4 p {\r\n    text-align: center;\r\n    padding-right: 96px;\r\n}\r\n.using-hcp-box td {\r\n    background-color: transparent;\r\n    border: 0;\r\n    vertical-align: top;\r\n    padding: 2px !important;\r\n    color: #83156f;\r\n}\r\n.using-hcp-box.arrow-bottom:after {\r\n    content: \" \";\r\n    position: absolute;\r\n    border-top: 25px solid #f4f4fa;\r\n    border-right: 25px solid transparent;\r\n    border-left: 25px solid transparent;\r\n    border-bottom: none;\r\n    margin-left: 22%;\r\n}\r\n.using-hcp-box4:after {\r\n    margin-top: -22px;\r\n}\r\n.using-hcp-box2.arrow-bottom:after {\r\n    margin-top: 20px;\r\n    margin-left: 22%;\r\n}\r\n.title-box2 {\r\n    width: 100%;\r\n    display: block;\r\n    background-color: #b4bf34;\r\n    color: #fff;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    background-size: cover;\r\n}\r\n.title-box2-drug {\r\n    width: 100%;\r\n    display: block;\r\n    color: #fff;\r\n    text-transform: uppercase;\r\n    padding-top: 15px;\r\n    padding-bottom: 10px;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    height: 57px;\r\n    background-image: url(../images/box1-blue.png);\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    font-size: 18px;\r\n    background-size: cover;\r\n}\r\n.hcp .title-box2-drug {\r\n    width: 100%;\r\n    display: block;\r\n    color: #fff;\r\n    text-transform: uppercase;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    height: 57px;\r\n    background-image: url(../images/box1-blue.png);\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    font-size: 18px;\r\n    background-size: cover;\r\n}\r\n.title-box2-inf {\r\n    width: 100%;\r\n    display: block;\r\n    color: #fff;\r\n    text-transform: uppercase;\r\n    padding-top: 15px;\r\n    padding-bottom: 10px;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    height: 57px;\r\n    background-image: url(../images/box1-yellow.png);\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    font-size: 18px;\r\n    margin-top: 20px;\r\n    background-size: cover;\r\n}\r\n.home h1 {\r\n}\r\n.read-more {\r\n    color: #0071d1;\r\n    text-decoration: none;\r\n}\r\n.isi {\r\n    width: 100%;\r\n    display: block;\r\n    float: left;\r\n    margin-top: 50px;\r\n    margin-bottom: 30px;\r\n}\r\np.fax span {\r\n    padding-top: 5px;\r\n    display: block;\r\n}\r\n.see-more-isi {\r\n    /* background-image:url(../images/see-sag.png);*/\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    padding-left: 15px;\r\n    color: #fff;\r\n    text-decoration: none;\r\n}\r\nh2.isi {\r\n    font-size: 16px;\r\n    margin-top: 20px;\r\n}\r\n.patients h2.isi {\r\n}\r\n.right-isi {\r\n    float: right;\r\n}\r\na {\r\n    color: #458ec1;\r\n}\r\n.patients a {\r\n    color: #83156f;\r\n}\r\n\r\n.footer .privacy a {\r\n    color: #fff;\r\n    text-decoration: none;\r\n}\r\n.footer .float-right {\r\n    padding-left: 130px;\r\n}\r\n.footer .float-right p {\r\n    width: 100%;\r\n    float: left;\r\n}\r\n.footer {\r\n    width: 100%;\r\n    display: block;\r\n    float: left;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    background-color: #83156f;\r\n    min-height: 170px;\r\n    color: #fff;\r\n}\r\n\r\n.fixed-footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n}\r\n.header-isi {\r\n    background-color: #83156f;\r\n    color: #fff;\r\n    padding-bottom: 10px;\r\n    padding-top: 10px;\r\n}\r\n.ui-widget {\r\n    font-size: 14px !important;\r\n}\r\n.patients .header-isi {\r\n}\r\n.see-more-isi {\r\n    float: right;\r\n}\r\n.isi-title {\r\n    float: left;\r\n}\r\n::-moz-selection {\r\n    background: #b3d4fc;\r\n    text-shadow: none;\r\n}\r\n\r\n::selection {\r\n    background: #b3d4fc;\r\n    text-shadow: none;\r\n}\r\n.hcp .user-area .size {\r\n    display: none;\r\n}\r\n\r\n/*\r\n  * A better looking default horizontal rule\r\n  */\r\n\r\nhr {\r\n    display: block;\r\n    height: 1px;\r\n    border: 0;\r\n    border-top: 1px solid #ccc;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\n/*\r\n  * Remove the gap between images and the bottom of their containers: h5bp.com/i/440\r\n  */\r\n\r\nimg {\r\n    vertical-align: middle;\r\n}\r\n\r\n/*\r\n  * Remove default fieldset styles.\r\n  */\r\n\r\nfieldset {\r\n    border: 0;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n/*\r\n  * Allow only vertical resizing of textareas.\r\n  */\r\n\r\ntextarea {\r\n    resize: vertical;\r\n}\r\n\r\n/* ==========================================================================\r\n  Chrome Frame prompt\r\n  ========================================================================== */\r\n\r\n.chromeframe {\r\n    margin: 0.2em 0;\r\n    background: #ccc;\r\n    color: #000;\r\n    padding: 0.2em 0;\r\n}\r\n\r\n/* ==========================================================================\r\n  Author's custom styles\r\n  ========================================================================== */\r\n\r\n/* ==========================================================================\r\n  Helper classes\r\n  ========================================================================== */\r\n/*\r\n  * Image replacement\r\n  */\r\n\r\n.ir {\r\n    background-color: transparent;\r\n    border: 0;\r\n    overflow: hidden;\r\n    /* IE 6/7 fallback */\r\n    *text-indent: -9999px;\r\n}\r\n\r\n.ir:before {\r\n    content: \"\";\r\n    display: block;\r\n    width: 0;\r\n    height: 150%;\r\n}\r\n\r\n/*\r\n  * Hide from both screenreaders and browsers: h5bp.com/u\r\n  */\r\n\r\n.hidden {\r\n    display: none !important;\r\n    visibility: hidden;\r\n}\r\n\r\n/*\r\n  * Hide only visually, but have it available for screenreaders: h5bp.com/v\r\n  */\r\n\r\n.visuallyhidden {\r\n    border: 0;\r\n    clip: rect(0 0 0 0);\r\n    height: 1px;\r\n    margin: -1px;\r\n    overflow: hidden;\r\n    padding: 0;\r\n    position: absolute;\r\n    width: 1px;\r\n}\r\n\r\n/*\r\n  * Extends the .visuallyhidden class to allow the element to be focusable\r\n  * when navigated to via the keyboard: h5bp.com/p\r\n  */\r\n\r\n.visuallyhidden.focusable:active,\r\n.visuallyhidden.focusable:focus {\r\n    clip: auto;\r\n    height: auto;\r\n    margin: 0;\r\n    overflow: visible;\r\n    position: static;\r\n    width: auto;\r\n}\r\n\r\n/*\r\n  * Hide visually and from screenreaders, but maintain layout\r\n  */\r\n\r\n.invisible {\r\n    visibility: hidden;\r\n}\r\n\r\n/*\r\n  * Clearfix: contain floats\r\n  *\r\n  * For modern browsers\r\n  * 1. The space content is one way to avoid an Opera bug when the\r\n  *    `contenteditable` attribute is included anywhere else in the document.\r\n  *    Otherwise it causes space to appear at the top and bottom of elements\r\n  *    that receive the `clearfix` class.\r\n  * 2. The use of `table` rather than `block` is only necessary if using\r\n  *    `:before` to contain the top-margins of child elements.\r\n  */\r\n\r\n.clearfix:before,\r\n.clearfix:after {\r\n    content: \" \"; /* 1 */\r\n    display: table; /* 2 */\r\n}\r\n\r\n.clearfix:after {\r\n    clear: both;\r\n}\r\n\r\n/*\r\n  * For IE 6/7 only\r\n  * Include this rule to trigger hasLayout and contain floats.\r\n  */\r\n\r\n.clearfix {\r\n    *zoom: 1;\r\n}\r\n\r\n/* ==========================================================================\r\n  EXAMPLE Media Queries for Responsive Design.\r\n  Theses examples override the primary ('mobile first') styles.\r\n  Modify as content requires.\r\n  ========================================================================== */\r\n\r\n@media only screen and (min-width: 35em) {\r\n    /* Style adjustments for viewports that meet the condition */\r\n}\r\n\r\n@media print, (-o-min-device-pixel-ratio: 5/4), (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {\r\n    /* Style adjustments for high resolution devices */\r\n}\r\n\r\n/* ==========================================================================\r\n  Jquery Modal.\r\n  \r\n  ========================================================================== */\r\n.modal {\r\n    background-color: #fff;\r\n    display: none;\r\n    width: 350px;\r\n    padding: 15px;\r\n    text-align: left;\r\n    border: 2px solid #333;\r\n    -moz-border-radius: 6px;\r\n    -webkit-border-radius: 6px;\r\n    -moz-box-shadow: 0 0 50px #ccc;\r\n    -webkit-box-shadow: 0 0 50px #ccc;\r\n}\r\n\r\n/* ==========================================================================\r\n  Print styles.\r\n  Inlined to avoid required HTTP connection: h5bp.com/r\r\n  ========================================================================== */\r\n\r\n@media print {\r\n    * {\r\n        background: transparent !important;\r\n        color: #000 !important; /* Black prints faster: h5bp.com/s */\r\n        box-shadow: none !important;\r\n        text-shadow: none !important;\r\n    }\r\n    a,\r\n    a:visited {\r\n        text-decoration: underline;\r\n    }\r\n    a[href]:after {\r\n        content: \" (\" attr(href) \")\";\r\n    }\r\n    abbr[title]:after {\r\n        content: \" (\" attr(title) \")\";\r\n    }\r\n\r\n    .ir a:after,\r\n    a[href^=\"javascript:\"]:after,\r\n    a[href^=\"#\"]:after {\r\n        content: \"\";\r\n    }\r\n\r\n    pre,\r\n    blockquote {\r\n        border: 1px solid #999;\r\n        page-break-inside: avoid;\r\n    }\r\n\r\n    thead {\r\n        display: table-header-group;\r\n    }\r\n\r\n    tr,\r\n    img {\r\n        page-break-inside: avoid;\r\n    }\r\n\r\n    img {\r\n        max-width: 100% !important;\r\n    }\r\n\r\n    @page {\r\n        margin: 0.5cm;\r\n    }\r\n\r\n    p,\r\n    h2,\r\n    h3 {\r\n        orphans: 3;\r\n        widows: 3;\r\n    }\r\n    h2,\r\n    h3 {\r\n        page-break-after: avoid;\r\n    }\r\n\r\n    .googleMap .-sectionBody {\r\n        width: 1300px;\r\n        float: left;\r\n    }\r\n    .googleMap #pageContent h1,\r\n    .googleMap .backList {\r\n        display: none;\r\n    }\r\n    .googleMap .-sectionBody,\r\n    .googleMap .resultDataMap {\r\n        border: none;\r\n    }\r\n\r\n    .googleMap .resultDataMap .facilityListItem {\r\n        float: left;\r\n        width: 500px !important;\r\n    }\r\n    .googleMap .resultDataMap .colOne {\r\n        float: left;\r\n        width: 28px;\r\n        display: block;\r\n    }\r\n    .googleMap .resultDataMap span.mapMarker {\r\n        display: block;\r\n        height: 38px;\r\n        margin: 0 10px;\r\n        width: 28px;\r\n    }\r\n    .googleMap .resultDataMap .colTwo {\r\n        float: left;\r\n        width: 85%;\r\n        display: block;\r\n        margin-left: 20px;\r\n        margin-top: -15px;\r\n    }\r\n    .googleMap #facilityLocatorMap {\r\n        float: left;\r\n        height: 700px !important;\r\n        width: 700px !important;\r\n        dispaly: block;\r\n    }\r\n}\r\n.progressbar {\r\n    counter-reset: step;\r\n    width: 100%;\r\n    display: block;\r\n    float: left;\r\n    margin-top: 20px;\r\n}\r\n#container .progressbar li {\r\n    list-style-type: none;\r\n    width: 16.6%;\r\n    float: left;\r\n    font-size: 12px;\r\n    position: relative;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    color: #7d7d7d;\r\n    list-style: none;\r\n    margin-left: 0;\r\n}\r\n.progressbar li:before {\r\n    width: 30px;\r\n    height: 30px;\r\n    content: \" \";\r\n    counter-increment: step;\r\n    line-height: 30px;\r\n    border: 2px solid #7d7d7d;\r\n    display: block;\r\n    text-align: center;\r\n    margin: 0 auto 10px auto;\r\n    border-radius: 50%;\r\n    background-color: white;\r\n}\r\n.progressbar li:after {\r\n    width: 100%;\r\n    height: 2px;\r\n    content: \"\";\r\n    position: absolute;\r\n    background-color: #7d7d7d;\r\n    top: 15px;\r\n    left: -50%;\r\n    z-index: -1;\r\n}\r\n.progressbar li:first-child:after {\r\n    content: none;\r\n}\r\n.progressbar li.active {\r\n    color: #83156f;\r\n}\r\n.progressbar li.active:before {\r\n    background-color: #83156f;\r\n    border-color: #83156f;\r\n    color: #fff;\r\n}\r\n.progressbar li.active + li:after {\r\n    background-color: #83156f;\r\n}\r\n\r\n.progressbar li.active {\r\n    color: #83156f;\r\n}\r\n.progressbar li.active:before {\r\n    background-color: #83156f;\r\n    border-color: #83156f;\r\n    color: #fff;\r\n    background-image: url(../images/check.png);\r\n    background-repeat: no-repeat;\r\n    background-size: 15px;\r\n    background-position: center;\r\n}\r\n.progressbar li.active + li:after {\r\n    /* background-image: url(../images/g.jpg);*/\r\n    background-repeat: repeat-x;\r\n}\r\n.progressbar li.current:before {\r\n    background-color: #83156f;\r\n    border-color: #83156f;\r\n    color: #fff;\r\n    background-image: url(../images/pencil.png);\r\n    background-repeat: no-repeat;\r\n    background-size: 15px;\r\n    background-position: center;\r\n}\r\n\r\n.form_error_message {\r\n    color: #990000;\r\n}\r\n\r\n.genericError {\r\n    color: #990000;\r\n}\r\n.top-mobile {\r\n    display: none;\r\n}\r\n@media all and (min-width: 320px) and (max-width: 320px) {\r\n    table {\r\n        margin: 20px 0px;\r\n    }\r\n}\r\n@media all and (min-width: 320px) and (max-width: 481px) {\r\n    .hcp button {\r\n        float: left;\r\n    }\r\n}\r\np.date-mobil {\r\n    display: none;\r\n}\r\n@media all and (min-width: 320px) and (max-width: 767px) {\r\n    .desktop {\r\n        display: none;\r\n    }\r\n    .mobile {\r\n        display: block;\r\n    }\r\n    .call {\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n    .fax {\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n    .left_text {\r\n        width: 100%;\r\n        float: left;\r\n    }\r\n    .right_text {\r\n        width: 100%;\r\n        float: left;\r\n        padding: 20px;\r\n        box-shadow: 0 0 7px;\r\n        margin-top: 40px;\r\n    }\r\n    .holidays-popup .popup-box {\r\n        width: auto;\r\n    }\r\n    .footer .col-md-7 {\r\n        width: 100% !important;\r\n        margin-bottom: 20px;\r\n    }\r\n    .border-right {\r\n        border: 0;\r\n    }\r\n    .right-top {\r\n        padding-right: 0;\r\n        width: 100%;\r\n    }\r\n    .top-header {\r\n        width: 100%;\r\n        float: left;\r\n    }\r\n\r\n    .content-buttons {\r\n        float: left !important;\r\n        width: 90% !important;\r\n    }\r\n    .title-home {\r\n        background-color: #83156f;\r\n        height: inherit;\r\n        padding-top: 15px;\r\n        padding-bottom: 15px;\r\n        background-image: none;\r\n        border-radius: 20px 20px 0px 0px;\r\n    }\r\n    p.date {\r\n        display: none;\r\n    }\r\n    p.date-mobil {\r\n        display: block;\r\n    }\r\n    p.date-mobil select {\r\n        width: 57px !important;\r\n    }\r\n    #dob_month_box {\r\n        width: 110px !important;\r\n    }\r\n    table.start_date {\r\n        width: 100%;\r\n    }\r\n    table.start_date td {\r\n        width: auto;\r\n        float: left;\r\n        clear: both;\r\n    }\r\n    .patients th {\r\n        background-repeat: repeat;\r\n    }\r\n    #submit-skip {\r\n        margin-top: 20px;\r\n    }\r\n    .pi_tab1 {\r\n        width: 100% !important;\r\n    }\r\n    .ui-tabs .ui-tabs-panel {\r\n        width: 100%;\r\n        padding: 0 !important;\r\n    }\r\n    p.date-mobil .date-box {\r\n        margin-right: 10px;\r\n    }\r\n    p.date-mobil label {\r\n        width: 100%;\r\n        float: left;\r\n        text-align: left;\r\n    }\r\n    label {\r\n        width: 100%;\r\n        float: left;\r\n        text-align: left;\r\n        padding-bottom: 7px;\r\n    }\r\n    .formBox label {\r\n        margin-bottom: 0;\r\n    }\r\n    #container #account_details ul li {\r\n        list-style: none;\r\n        padding-left: 0;\r\n        margin-left: 0;\r\n    }\r\n    .ui-tabs .ui-tabs-nav {\r\n        display: block !important;\r\n    }\r\n    .ui-tabs .ui-tabs-nav a {\r\n        margin-top: 5px !important;\r\n    }\r\n    #account_details {\r\n        float: left;\r\n        margin-top: 10px;\r\n    }\r\n    .leftSpace {\r\n        width: 100%;\r\n        border: 0;\r\n        margin-bottom: 0;\r\n    }\r\n    .rightSpace {\r\n        width: 100%;\r\n        border: 0;\r\n        padding-left: 0;\r\n        margin-bottom: 20px;\r\n    }\r\n    .alpha-filter table td {\r\n        width: 30px;\r\n        float: left;\r\n    }\r\n    .alpha-filter {\r\n        float: left;\r\n        background-color: #e8e8e8;\r\n    }\r\n    .patients td.like-td {\r\n        text-align: center !important;\r\n        padding: 10px !important;\r\n        width: 40%;\r\n    }\r\n    .patients td.like-th {\r\n        padding: 10px !important;\r\n        width: 60%;\r\n    }\r\n    .patients td.like-th {\r\n        background-repeat: repeat;\r\n    }\r\n    p.nothave-field label {\r\n        width: 90%;\r\n    }\r\n    p.nothave-field-2 label {\r\n        width: 90%;\r\n    }\r\n    .top a {\r\n        width: 100%;\r\n        margin-bottom: 1px;\r\n    }\r\n    .responsive-button {\r\n        cursor: pointer;\r\n        margin-top: 20px;\r\n        background-color: #83156f;\r\n        border: 1px solid #458ec1;\r\n        font-size: 16px;\r\n        padding: 10px 14px 10px 15px;\r\n        margin-bottom: 0px !important;\r\n        color: #fff;\r\n        width: 100%;\r\n    }\r\n    .responsive-button-submenu {\r\n        width: 100%;\r\n    }\r\n    #nav {\r\n        /* display: none; */\r\n    }\r\n    .nav > li > a {\r\n        width: 100%;\r\n        display: block;\r\n        float: left;\r\n        text-align: left;\r\n    }\r\n    .after-title {\r\n        padding: 20px !important;\r\n    }\r\n    .five-cost {\r\n        width: 100%;\r\n        margin-bottom: 20px;\r\n    }\r\n    .five-cost .col-xs-10 {\r\n        width: 70%;\r\n    }\r\n    .five-cost span {\r\n        padding-right: 0;\r\n        display: block;\r\n    }\r\n\r\n    .col2 {\r\n        width: 100%;\r\n        float: left;\r\n    }\r\n    .col1 {\r\n        width: 100%;\r\n        float: left;\r\n    }\r\n    .radio {\r\n        line-height: 20px !important;\r\n    }\r\n    .cost2 {\r\n        padding-left: 0px;\r\n    }\r\n\r\n    .find_patient .select_container {\r\n        width: 100%;\r\n        margin-bottom: 20px;\r\n        margin-right: 0;\r\n    }\r\n    .select_container select {\r\n        width: 90%;\r\n        max-width: 100%;\r\n    }\r\n    .find_patient input[type=\"text\"] {\r\n        max-width: 100%;\r\n        width: 100%;\r\n        margin-bottom: 20px;\r\n    }\r\n    .col-sm-12.col-md-12 {\r\n        width: 100%;\r\n        float: left;\r\n    }\r\n    input[type=\"text\"],\r\n    input[type=\"password\"] {\r\n        width: 100%;\r\n    }\r\n    .patients .button.enroll {\r\n        display: block;\r\n        float: none;\r\n        margin: 0 auto;\r\n        font-family: \"Avenir Next LT W01 Bold\";\r\n    }\r\n    .patients .button.account {\r\n        display: block;\r\n        float: none;\r\n        margin: 0 auto;\r\n        margin-top: 20px;\r\n        font-family: \"Avenir Next LT W01 Bold\";\r\n    }\r\n    .find_patient {\r\n        width: 100%;\r\n        float: left;\r\n        margin-bottom: 20px;\r\n    }\r\n    .hcp .nav li,\r\n    .submenu .nav li {\r\n        width: 100%;\r\n    }\r\n    .hcp .nav li,\r\n    .submenu .nav li a {\r\n        width: 100%;\r\n    }\r\n    .five-cost img {\r\n        margin-bottom: 50px;\r\n    }\r\n    .nav li {\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n    .text-enlarger {\r\n        width: 260px;\r\n    }\r\n    .top-header {\r\n        padding-top: 20px;\r\n    }\r\n    .title {\r\n        width: 100%;\r\n    }\r\n    .text-enlarger-body {\r\n        width: 100%;\r\n    }\r\n    .title-holder {\r\n        width: 100%;\r\n    }\r\n    .size-link {\r\n        display: inline-block;\r\n        text-align: left;\r\n        line-height: normal;\r\n        text-decoration: none;\r\n        background: none;\r\n        width: 90%;\r\n        height: auto;\r\n        color: #000;\r\n        border: 2px solid #f58425;\r\n        padding: 15px;\r\n        border-radius: 10px;\r\n    }\r\n    .responsive-button span {\r\n        margin-left: 15px;\r\n    }\r\n    .responsive-button.active {\r\n        margin-top: 20px;\r\n        color: #fff;\r\n    }\r\n    .five-cost .center-col_1 img {\r\n        margin: 0 auto;\r\n        float: none;\r\n        margin-bottom: 20px;\r\n    }\r\n    .five-cost .center-col_2 img {\r\n        margin: 0 auto;\r\n        float: none;\r\n        margin-bottom: 20px;\r\n    }\r\n    .center-col_1 {\r\n        width: 100%;\r\n        float: left;\r\n        text-align: center;\r\n        padding: 0px;\r\n        border-right: 0;\r\n        margin-top: 20px;\r\n    }\r\n    .center-col_2 {\r\n        width: 100%;\r\n        float: left;\r\n        text-align: center;\r\n        padding: 0px;\r\n        border-right: 0;\r\n    }\r\n    ul.submenuitems {\r\n        position: relative;\r\n    }\r\n    ul.submenuitems li a {\r\n        padding-left: 45px;\r\n    }\r\n\r\n    .ui-combobox {\r\n        width: 70px;\r\n    }\r\n    #CombifyInput-dob-month {\r\n        width: 60px;\r\n    }\r\n    #CombifyInput-dob-day {\r\n        width: 60px;\r\n    }\r\n    #CombifyInput-dob-year {\r\n        width: 60px;\r\n    }\r\n    .top {\r\n        display: none;\r\n    }\r\n    #onetrust-banner-sdk.top {\r\n        display: block;\r\n    }\r\n    .top-mobile {\r\n        display: block;\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n    .top-mobile .container {\r\n        padding: 0;\r\n    }\r\n    .top-mobile a {\r\n        color: #fff !important;\r\n        background-color: #458ec1;\r\n        padding: 10px;\r\n        display: block;\r\n        float: left;\r\n        text-decoration: none;\r\n        font-size: 15px;\r\n        text-align: center;\r\n        min-height: 80px;\r\n    }\r\n    .top-mobile a.active {\r\n        color: #4d4d4f !important;\r\n        background-color: #f4f4f4;\r\n        display: block;\r\n        float: left;\r\n        text-decoration: none;\r\n        font-size: 15px;\r\n        border: 1px solid #d8d8d8;\r\n    }\r\n    .top-mobile a {\r\n        width: 40%;\r\n        display: block;\r\n        float: left;\r\n        padding-top: 14px;\r\n    }\r\n    .top-mobile a.hcp-tab {\r\n        width: 60%;\r\n        display: block;\r\n        float: left;\r\n        padding-top: 10px;\r\n    }\r\n    .right-top a {\r\n        width: 100%;\r\n        float: left;\r\n    }\r\n    .hide-mobil {\r\n        display: none;\r\n    }\r\n    .responsive-button-submenu {\r\n        cursor: pointer;\r\n        margin-top: 20px;\r\n        background: #83156f;\r\n        color: #ffffff;\r\n        font-size: 16px;\r\n        padding: 10px 14px 10px 15px;\r\n        margin-bottom: 0px !important;\r\n        margin-right: 5px;\r\n        border: 1px solid #606384 !important;\r\n    }\r\n    .hcp #navsubmenu li a:hover {\r\n        background-color: #83156f;\r\n        text-decoration: none;\r\n        border: 1px solid #606384 !important;\r\n        color: #fff;\r\n    }\r\n    .responsive-button-submenu span {\r\n        margin-left: 15px;\r\n    }\r\n    .responsive-button-submenu.active {\r\n        margin-top: 20px;\r\n        border: 1px solid #606384 !important;\r\n    }\r\n\r\n    .submenu li a {\r\n    }\r\n\r\n    .nav a {\r\n    }\r\n    .nav li {\r\n        margin-bottom: 0px !important;\r\n    }\r\n    .patients .nav .selected a {\r\n    }\r\n    .hcp .nav .selected a {\r\n    }\r\n    .nav > li > a {\r\n        padding: 10px 45px !important;\r\n    }\r\n    #header {\r\n        margin-bottom: 0px;\r\n        padding: 0 !important;\r\n    }\r\n    #header-patients #nav li a:hover {\r\n    }\r\n    #header-hcp #nav li a:hover {\r\n    }\r\n    .right-top {\r\n        float: left;\r\n        margin-bottom: 10px;\r\n    }\r\n    table.patient-list {\r\n        border-collapse: separate;\r\n        border-spacing: 2px;\r\n        display: block;\r\n        overflow-x: auto;\r\n        width: 100%;\r\n    }\r\n    #home-container {\r\n        margin-top: 20px;\r\n        margin-bottom: 25px;\r\n        padding: 10px 10px 30px 10px;\r\n    }\r\n    #home-container-patients {\r\n        margin-top: 10px;\r\n        margin-bottom: 10px;\r\n    }\r\n    #home-container-hcp {\r\n        margin-top: 10px;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .createaccount {\r\n        float: left;\r\n        margin-top: 10px;\r\n        margin-bottom: 20px;\r\n    }\r\n    .date-box {\r\n        margin-top: 5px;\r\n        float: none;\r\n    }\r\n    #container .progressbar li {\r\n        color: #ffffff;\r\n    }\r\n    .eligibility .col-lg-6 {\r\n        width: 100%;\r\n    }\r\n    .scrollableArea {\r\n        width: 100% !important;\r\n    }\r\n    .submenu .nav {\r\n        width: 100%;\r\n    }\r\n    .eligibility .col-lg-4 {\r\n        width: 100%;\r\n    }\r\n    .hcp-popup .popup-box {\r\n        width: 90%;\r\n    }\r\n}\r\n\r\n@media all and (min-width: 320px) and (max-width: 500px) {\r\n    .patients .button.enroll {\r\n        float: none !important;\r\n        margin: 0 auto !important;\r\n        display: block;\r\n        margin-top: 10px !important;\r\n    }\r\n    .patients .button.account {\r\n        float: none !important;\r\n\r\n        margin: 0 auto !important;\r\n        display: block;\r\n        margin-top: 20px !important;\r\n    }\r\n}\r\n\r\n@media all and (min-width: 768px) and (max-width: 990px) {\r\n    .right-top {\r\n        margin-top: 0;\r\n        margin-bottom: 20px;\r\n    }\r\n    .patients .button.enroll {\r\n        float: none;\r\n        display: inline-block;\r\n    }\r\n    .patients .button.account {\r\n        margin-right: 0px !important;\r\n        float: none;\r\n        display: inline-block;\r\n    }\r\n    .patients .button {\r\n        float: none;\r\n        width: 230px;\r\n    }\r\n    .eligibility .col-lg-6 {\r\n        width: 100%;\r\n    }\r\n    .eligibility .col-lg-4 {\r\n        width: 100%;\r\n    }\r\n}\r\n@media all and (min-width: 320px) and (max-width: 481px) {\r\n    a.logo img {\r\n        max-width: 100%;\r\n    }\r\n    div.container {\r\n        width: 100%;\r\n    }\r\n    .hcp button {\r\n        float: left;\r\n    }\r\n    .padding {\r\n        margin-left: 0;\r\n    }\r\n}\r\n.using4 .padding {\r\n    margin-left: 17px;\r\n}\r\n.dont-break-out {\r\n    /* These are technically the same, but use both */\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n\r\n    -ms-word-break: break-all;\r\n    /* This is the dangerous one in WebKit, as it breaks things wherever */\r\n    word-break: break-all;\r\n    /* Instead use this non-standard one: */\r\n    word-break: break-word;\r\n\r\n    /* Adds a hyphen where the word breaks, if supported (No Blink) */\r\n    -ms-hyphens: auto;\r\n    -moz-hyphens: auto;\r\n    -webkit-hyphens: auto;\r\n    hyphens: auto;\r\n}\r\n@media all and (min-width: 320px) and (max-width: 750px) {\r\n    .using4 .padding {\r\n        margin-left: 15px;\r\n    }\r\n    .using4 ul {\r\n        margin-left: 0px;\r\n    }\r\n    .using4 img {\r\n        max-width: 30px;\r\n    }\r\n    ul.user-area {\r\n        display: block;\r\n    }\r\n    .user-box {\r\n        margin-top: 0px;\r\n        float: left;\r\n        padding: 10px;\r\n    }\r\n    #tabs .nav li {\r\n        width: 100%;\r\n    }\r\n    .using1 img {\r\n        display: none;\r\n    }\r\n    .using3 img {\r\n        display: none;\r\n    }\r\n    .using4 img {\r\n        display: none;\r\n    }\r\n    .using5 img {\r\n        display: none;\r\n    }\r\n    .nav.user-area .icon-mm a.round-mm {\r\n        width: 40px;\r\n        text-align: center;\r\n        float: right;\r\n    }\r\n    .using1-hcp {\r\n        background-image: url(\"../images/using1-m.png\");\r\n        background-repeat: no-repeat;\r\n        margin-top: 10px;\r\n        padding-left: 60px;\r\n        padding-right: 40px;\r\n        padding-top: 20px;\r\n        text-align: left;\r\n        width: 100%;\r\n        background-position: top left;\r\n        background-color: #83156f;\r\n        border-radius: 10px;\r\n        padding-bottom: 20px;\r\n        border-radius: 20px;\r\n        padding-bottom: 20px;\r\n        float: left;\r\n        height: auto;\r\n    }\r\n    .using3-hcp {\r\n        background-image: url(\"../images/using3-m.png\");\r\n        background-repeat: no-repeat;\r\n        margin-top: 20px;\r\n        padding-left: 60px;\r\n        padding-right: 20px;\r\n        padding-top: 20px;\r\n        text-align: left;\r\n        width: 100%;\r\n        background-position: top left;\r\n        background-color: #83156f;\r\n        border-radius: 10px;\r\n        padding-bottom: 20px;\r\n        border-radius: 20px;\r\n        padding-bottom: 20px;\r\n        float: left;\r\n        height: auto;\r\n    }\r\n    .using3-hcp img {\r\n        display: none;\r\n    }\r\n    .using2-hcp {\r\n        background-image: url(\"../images/using2-m.png\");\r\n        background-repeat: no-repeat;\r\n        margin-top: 20px;\r\n        padding-left: 60px;\r\n        padding-right: 50px;\r\n        padding-top: 20px;\r\n        text-align: left;\r\n        width: 100%;\r\n        background-position: top right;\r\n        background-color: #83156f;\r\n        border-radius: 10px;\r\n        padding-bottom: 20px;\r\n        border-radius: 20px;\r\n        padding-bottom: 20px;\r\n        float: left;\r\n        height: auto;\r\n    }\r\n    .using4-hcp {\r\n        background-image: url(\"../images/using4-m.png\");\r\n        background-repeat: no-repeat;\r\n        height: 140px;\r\n        margin-top: 20px;\r\n        padding-left: 60px;\r\n        padding-right: 50px;\r\n        padding-top: 20px;\r\n        text-align: left;\r\n        width: 100%;\r\n        background-position: top right;\r\n        background-color: #83156f;\r\n        border-radius: 10px;\r\n        padding-bottom: 20px;\r\n        border-radius: 20px;\r\n        padding-bottom: 20px;\r\n        float: left;\r\n        height: auto;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .using1 {\r\n        background-image: url(\"../images/using1-m.png\");\r\n        background-repeat: no-repeat;\r\n        margin-top: 10px;\r\n        padding-left: 60px;\r\n        padding-right: 40px;\r\n        padding-top: 20px;\r\n        text-align: left;\r\n        width: 100%;\r\n        background-position: top left;\r\n        background-color: #83156f;\r\n        border-radius: 10px;\r\n        padding-bottom: 20px;\r\n        border-radius: 20px;\r\n        padding-bottom: 20px;\r\n        float: left;\r\n        height: auto;\r\n    }\r\n    .using3 {\r\n        background-image: url(\"../images/using3-m.png\");\r\n        background-repeat: no-repeat;\r\n        margin-top: 20px;\r\n        padding-left: 60px;\r\n        padding-right: 20px;\r\n        padding-top: 20px;\r\n        text-align: left;\r\n        width: 100%;\r\n        background-position: top left;\r\n        background-color: #83156f;\r\n        border-radius: 10px;\r\n        padding-bottom: 20px;\r\n        border-radius: 20px;\r\n        padding-bottom: 20px;\r\n        float: left;\r\n        height: auto;\r\n    }\r\n\r\n    .using2 {\r\n        background-image: url(\"../images/using2-m.png\");\r\n        background-repeat: no-repeat;\r\n        margin-top: 20px;\r\n        padding-left: 60px;\r\n        padding-right: 50px;\r\n        padding-top: 20px;\r\n        text-align: left;\r\n        width: 100%;\r\n        background-position: top right;\r\n        background-color: #83156f;\r\n        border-radius: 10px;\r\n        padding-bottom: 20px;\r\n        border-radius: 20px;\r\n        padding-bottom: 20px;\r\n        float: left;\r\n        height: auto;\r\n    }\r\n    .using4 {\r\n        background-image: url(\"../images/using4-m.png\");\r\n        background-repeat: no-repeat;\r\n        height: 140px;\r\n        margin-top: 20px;\r\n        padding-left: 60px;\r\n        padding-right: 50px;\r\n        padding-top: 20px;\r\n        text-align: left;\r\n        width: 100%;\r\n        background-position: top right;\r\n        background-color: #83156f;\r\n        border-radius: 10px;\r\n        padding-bottom: 20px;\r\n        border-radius: 20px;\r\n        padding-bottom: 20px;\r\n        float: left;\r\n        height: auto;\r\n        margin-bottom: 20px;\r\n    }\r\n    .using5 {\r\n        background-image: url(\"../images/using5-m.png\");\r\n        background-repeat: no-repeat;\r\n        height: 140px;\r\n        margin-top: 20px;\r\n        padding-left: 60px;\r\n        padding-right: 50px;\r\n        padding-top: 20px;\r\n        text-align: left;\r\n        width: 100%;\r\n        background-position: top right;\r\n        background-color: #83156f;\r\n        border-radius: 10px;\r\n        padding-bottom: 20px;\r\n        border-radius: 20px;\r\n        padding-bottom: 20px;\r\n        float: left;\r\n        height: auto;\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n\r\n#header-patients #nav li a:hover {\r\n    background-color: #83156f;\r\n    text-decoration: none;\r\n    color: #fff;\r\n}\r\n#header-patients #nav ul.submenuitems li a:hover {\r\n    border: 0 !important;\r\n    border-radius: 0px !important;\r\n}\r\n#nav li.selected a:hover {\r\n    border-radius: 0px !important;\r\n}\r\n#header-hcp #nav li a:hover {\r\n    background-color: #83156f;\r\n    text-decoration: none;\r\n    border: 1px solid #83156f !important;\r\n    color: #fff;\r\n}\r\n.footer {\r\n    font-weight: normal;\r\n}\r\n.isi h3 {\r\n    font-weight: bold;\r\n    font-size: 18px;\r\n    color: #83156f;\r\n}\r\n.hcp .isi h3 {\r\n    color: #83156f;\r\n}\r\n.hcp .footer {\r\n    background-color: #83156f;\r\n}\r\n.hcp a {\r\n    color: #83156f;\r\n}\r\n.hcp .isi p strong {\r\n    color: #4d4d4f;\r\n}\r\n\r\n/* Adaugate last */\r\n\r\n#navsubmenu {\r\n    height: auto;\r\n    border-top: 1px solid #ddd;\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n#navsubmenu li {\r\n    margin-left: 0 !important;\r\n    background: #fff;\r\n    margin-bottom: 0;\r\n    width: auto;\r\n    min-width: 160px;\r\n}\r\n#navsubmenu li a {\r\n    color: rgba(0, 0, 0, 0.57);\r\n    font-family: \"AvenirNextLTW01-Regular\";\r\n    background: #fff;\r\n    padding: 8px !important;\r\n    padding-bottom: 10px !important;\r\n    border: 0 !important;\r\n}\r\n#navsubmenu li.selected a {\r\n    background: #fff;\r\n    border-bottom: 2px solid #83156f !important;\r\n}\r\n.red {\r\n    color: red;\r\n}\r\n.color-label label {\r\n    color: #83156f;\r\n    font-size: 16px !important;\r\n    line-height: 20px !important;\r\n    margin-bottom: 3px;\r\n    width: 100%;\r\n}\r\n.color-label p {\r\n    min-height: inherit;\r\n}\r\np.alignright {\r\n    min-height: inherit;\r\n    text-align: right;\r\n}\r\ntable.account th {\r\n    background: #fff;\r\n    font-size: 14px !important;\r\n    color: rgba(0, 0, 0, 0.54);\r\n    font-family: \"Avenir Next LT W01 Bold\";\r\n    border-top: 2px solid #ddd;\r\n    padding: 10px;\r\n    border-bottom: 1px solid #ddd;\r\n}\r\ntable.account th:first-child {\r\n    padding-left: 20px;\r\n}\r\ntable.account td:first-child {\r\n    padding-left: 20px;\r\n}\r\ntable.account td {\r\n    font-size: 14px !important;\r\n    padding: 10px;\r\n}\r\n\r\ntable.account tr:nth-child(odd) td {\r\n    background: #fff;\r\n}\r\n\r\ntable.account tr:nth-child(even) td {\r\n    background: #f2f2f2;\r\n}\r\n\r\nbutton.save {\r\n    background: #fff;\r\n    border-radius: 5px;\r\n    margin-right: 0;\r\n}\r\nbutton.cancel {\r\n    background: #fff;\r\n    border-radius: 5px;\r\n}\r\n.info {\r\n    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);\r\n    border-radius: 4px;\r\n    display: block;\r\n    padding: 20px;\r\n    background: #fff;\r\n    padding-top: 10px;\r\n    padding-bottom: 5px;\r\n    margin-bottom: 10px;\r\n}\r\n.inner-drop {\r\n    position: relative;\r\n}\r\n\r\n#dropdown {\r\n    -webkit-box-shadow: 0px 3px 8px 2px #b5b5b5;\r\n    box-shadow: 0px 3px 8px 2px #b5b5b5;\r\n    border-radius: 5px;\r\n    background: #fff;\r\n    position: absolute;\r\n    top: 40px;\r\n    left: 0;\r\n    width: 240px;\r\n    font-size: 15px;\r\n}\r\n#dropdown-2 {\r\n    -webkit-box-shadow: 0px 3px 8px 2px #b5b5b5;\r\n    box-shadow: 0px 3px 8px 2px #b5b5b5;\r\n    border-radius: 5px;\r\n    background: #fff;\r\n    position: absolute;\r\n    top: 40px;\r\n    left: 0;\r\n    width: 300px;\r\n    font-size: 15px;\r\n}\r\n#dropdown p {\r\n    padding: 15px;\r\n    margin-bottom: 0;\r\n    background: #fff;\r\n}\r\n#dropdown-2 p {\r\n    padding: 15px;\r\n    margin-bottom: 0;\r\n    background: #fff;\r\n}\r\np.grey {\r\n    background: #f5f5f5 !important;\r\n}\r\n#dropdown .checkbox .checkmark {\r\n    top: 4px;\r\n}\r\n#dropdown-2 .checkbox .checkmark {\r\n    top: 4px;\r\n}\r\n#dropdown-2 label {\r\n    color: #4d4d4f !important;\r\n    font-size: 14px !important;\r\n}\r\n.inner-drop select {\r\n    width: 100%;\r\n    max-width: inherit;\r\n}\r\n.space {\r\n    width: 100%;\r\n    display: inline-block;\r\n    margin-bottom: 20px;\r\n}\r\n.user-box {\r\n    background-color: #fff;\r\n    padding: 15px;\r\n    width: 300px;\r\n    -webkit-box-shadow: 0px 3px 8px 2px #b5b5b5;\r\n    box-shadow: 0px 3px 8px 2px #b5b5b5;\r\n    top: 40px;\r\n    text-align: left;\r\n}\r\n.line-user.acc {\r\n    background-image: url(../images/icon-gear.png);\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    background-size: 20px;\r\n    padding-left: 40px;\r\n    height: 30px;\r\n    margin-bottom: 10px;\r\n    margin-left: 0;\r\n    color: #4d4d4f;\r\n}\r\n.line-user.psw {\r\n    background-image: url(../images/key-icon.png);\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    background-size: 20px;\r\n    padding-left: 20px;\r\n    padding-left: 40px;\r\n    height: 30px;\r\n    margin-bottom: 10px;\r\n    margin-left: 0;\r\n    color: #4d4d4f;\r\n}\r\n.line-user.out {\r\n    background-image: url(../images/logout-icon.png);\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    background-size: 20px;\r\n    padding-left: 40px;\r\n    height: 30px;\r\n    margin-bottom: 10px;\r\n    margin-left: 0;\r\n    color: #4d4d4f;\r\n}\r\n.nav.user-area .icon-mm a {\r\n    padding: 0px !important;\r\n    margin-bottom: 8px;\r\n    text-align: left;\r\n    background: none;\r\n    font-weight: normal;\r\n    color: #4d4d4f;\r\n}\r\n.round-mm {\r\n    width: 33px;\r\n    height: 33px;\r\n    border: 1px solid #6c757d;\r\n    color: #83156f;\r\n    padding: 2px;\r\n    padding-top: 3px;\r\n    font-size: 15px;\r\n    margin-left: 0;\r\n    margin-right: 5px;\r\n}\r\n.nav.user-area .icon-mm a.round-mm {\r\n    padding: 2px !important;\r\n    color: #83156f;\r\n    font-weight: bold;\r\n    border: 1px solid #6c757d !important;\r\n}\r\n.mm {\r\n    padding-top: 0;\r\n    padding-bottom: 10px;\r\n    border-bottom: 1px solid #6c757d;\r\n    margin-bottom: 10px;\r\n}\r\n.nav .icon-mm {\r\n    width: auto;\r\n}\r\n.user-area a {\r\n    color: #4d4d4f !important;\r\n}\r\n.nav.user-area .icon-mm a.round-mm {\r\n    color: #83156f !important;\r\n}\r\nul.submenuitems.user-box {\r\n    left: auto;\r\n    right: 0;\r\n}\r\n.font-bigger-size {\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n}\r\nbutton.update {\r\n    border: 0;\r\n    padding: 0;\r\n    text-decoration: underline;\r\n}\r\n#ui-datepicker-div {\r\n    width: 300px;\r\n}\r\n.ui-datepicker td span,\r\n.ui-datepicker td a {\r\n    padding: 7px !important;\r\n    text-align: center !important;\r\n    text-decoration: none !important;\r\n}\r\n.show-indication {\r\n    color: #00759f !important;\r\n    cursor: pointer;\r\n    margin-left: 25px;\r\n    text-decoration: none;\r\n}\r\n.table-bordered {\r\n    margin: 0;\r\n}\r\n.modal-header h3 {\r\n    color: #83156f;\r\n    font-size: 23px;\r\n    font-weight: normal;\r\n}\r\n.modal-header {\r\n    border-bottom: 0 !important;\r\n}\r\n.modal-body th {\r\n    background: #f8c121;\r\n    color: #fff;\r\n}\r\n.line-user.users {\r\n    background-image: url(../images/user-icon.png);\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    background-size: 20px;\r\n    padding-left: 40px;\r\n    height: 30px;\r\n    /* margin-left: 10px; */\r\n    margin-bottom: 10px;\r\n}\r\na.notif {\r\n    display: block;\r\n    float: right;\r\n    /* padding: 7px; */\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    margin-top: 3px;\r\n}\r\n.notif {\r\n    position: relative;\r\n}\r\n.notif img {\r\n    max-width: 20px;\r\n}\r\n.notif small {\r\n    background: #ff0000;\r\n    border-radius: 15px;\r\n    color: #fff;\r\n    font-weight: bold;\r\n    width: 18px;\r\n    height: 18px;\r\n    display: inline-block;\r\n    line-height: 12px;\r\n    font-size: 9px;\r\n    text-align: center;\r\n    margin-top: -5px;\r\n    position: absolute;\r\n    padding: 3px;\r\n}\r\na.button.fltright {\r\n    background-color: #fff;\r\n    color: #83156f !important;\r\n    border: 2px solid #83156f;\r\n    border-radius: 7px;\r\n    color: #fff;\r\n    padding: 8px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    text-decoration: none;\r\n    width: auto;\r\n    float: right;\r\n    height: auto;\r\n}\r\n#fancybox-close:hover {\r\n    background-color: #f0e3ed !important;\r\n}\r\n.patients .using-hcp-box table td {\r\n    padding-right: 7px !important;\r\n}\r\n.patients .using-hcp-box table td a {\r\n    text-decoration: none;\r\n}\r\n.no-box p {\r\n    margin-bottom: 15px;\r\n}\r\n.pad-left {\r\n    padding-left: 25px;\r\n}\r\n\r\n.checkbox {\r\n    display: block;\r\n    position: relative;\r\n    padding-left: 25px;\r\n    cursor: pointer;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    float: left;\r\n    margin-top: 0;\r\n}\r\n.checkbox .checkmark {\r\n    width: 15px;\r\n    height: 15px;\r\n}\r\n.checkbox input {\r\n    position: absolute;\r\n    opacity: 0;\r\n}\r\n\r\nlabel.checkbox {\r\n    text-align: left;\r\n}\r\n/* On mouse-over, add a grey background color */\r\n.checkbox:hover input ~ .checkmark {\r\n}\r\n\r\n/* When the checkbox button is checked, add a blue background */\r\n.checkbox input:checked ~ .checkmark {\r\n    background-color: #83156f;\r\n}\r\n\r\n/* Create the indicator (the dot/circle - hidden when not checked) */\r\n.checkmark:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    display: none;\r\n}\r\n.checkbox .checkmark {\r\n    border-radius: 0;\r\n}\r\n/* Show the indicator (dot/circle) when checked */\r\n.checkbox input:checked ~ .checkmark:after {\r\n    display: block;\r\n}\r\n\r\n/* Style the indicator (dot/circle) */\r\n.checkbox .checkmark:after {\r\n    width: 12px;\r\n    height: 12px;\r\n    background-color: #83156f;\r\n    background-image: url(../images/check-icon.png);\r\n    background-repeat: no-repeat;\r\n}\r\n.checkmark.error-check {\r\n    border: 1px solid #ff0000 !important;\r\n}\r\n.error-msj {\r\n    color: #721c24;\r\n    background-color: #f8d7da;\r\n    border-color: #f5c6cb;\r\n    padding: 20px;\r\n}\r\n.patients .page-alert .popup-box {\r\n    max-width: 800px;\r\n}\r\n.pages {\r\n    font-size: 13px;\r\n    text-align: center;\r\n    margin-top: 40px;\r\n    margin-bottom: 40px;\r\n    width: 100%;\r\n    float: left;\r\n}\r\n.nav-left {\r\n    display: inline-block;\r\n    width: 20px;\r\n    height: 20px;\r\n    background-image: url(../images/sag-left.png);\r\n    background-repeat: no-repeat;\r\n    margin-right: 40px;\r\n    color: #888;\r\n    margin-top: 5px;\r\n}\r\n.nav-right {\r\n    display: inline-block;\r\n    width: 20px;\r\n    height: 20px;\r\n    background-image: url(../images/sag-right.png);\r\n    background-repeat: no-repeat;\r\n    margin-top: 5px;\r\n}\r\n.pages select {\r\n    width: 50px;\r\n    border-bottom: 1px solid #4d4d4f;\r\n    padding-bottom: 3px;\r\n}\r\n.ui-widget {\r\n    font-family: \"AvenirNextLTW01-Regular\" !important;\r\n}\r\n#home-container-patients img {\r\n    width: 100%;\r\n}\r\n.hcp #home-container-patients {\r\n    margin-bottom: 20px;\r\n}\r\n.deactivate-popup button.save {\r\n    background: #ddd;\r\n}\r\n.activate-popup button.save {\r\n    background: #ddd;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
